/* eslint-disable */
const messages = {
  V: `v`,
  TEAM_ID: `ID: {id}`,
  TEAM_NAME: `Équipe: {name}`,
  DASHBOARD: `Dashboard`,
  INDICATOR: `Indicateur`,
  INDICATORS: `Indicateurs`,
  THEME: `Thème`,
  ACTION_PLANS: `Plans d'action`,
  PENDING: `Attente`,
  PROBLEMS: `Problèmes`,
  PROBLEMS_SHORT: `Prob.`,
  PROBLEM_SOLVING: `Résolution de problèmes`,
  DMP: `Management de la performance au quotidien`,
  SYNTHESIS: `Synthèse rituel`,
  STATS: `Statistiques`,
  INFORMATION: `Information`,
  INFORMATIONS: `Informations`,
  INFORMATIONS_SHORT: `Infos`,
  FILTERS: `Filtres`,
  ARCHIVES: `Archives`,
  SCHEDULE: `Agenda`,
  OPTIONS: `Options`,
  PROBLEM: `Problème`,
  NEW_PROBLEM: `Nouveau problème`,
  ADD_PROBLEM: `Ajouter un problème`,
  ADD_ACTION: `Ajouter une action`,
  SEARCH: `Recherche`,
  SEARCH_PH: `@:(message.SEARCH)…`,
  CAUSES: `Causes`,
  CAUSE: `Cause`,
  CAUSE_DESCRIPTION: `Description de la cause`,
  ACTION: `Action`,
  ACTIONS: `Actions`,
  ACTION_NAME: `Nom de l'action`,
  MEETINGS: `Réunions`,
  MEETINGS_SHORT: `Réu.`,
  LANGUAGE: `Langue`,
  SUMMARY: `Résumé`,
  CLOSE: `Fermer`,
  SUBMIT: `Valider`,
  SORT: `Tri`,
  TWO_DOTS: ` : `,
  HYPHEN: `-`,
  LOGIN: `Connexion`,
  SECURE_AUTHENTICATION: `Authentification sécurisée`,
  CANCEL: `Annuler`,
  DELETE: `Supprimer`,
  RESTORE: `Restaurer`,
  IGNORE: `Ignorer`,
  TAGS: `Tags`,
  TO_BE_DEFINED: `À définir`,
  SELECT_COLOR: `Sélectionnez une couleur`,
  NONE: `Aucun`,
  NONE_FEM: `Aucune`,
  OK: `Ok`,
  GW_OK: `OK`,
  GW_NOK: `NOK`,
  YES: `Oui`,
  NO: `Non`,
  REALLY_BAD: `Très mauvais`,
  BAD: `Mauvais`,
  NOT_SO_GOOD: `Pas terrible`,
  OKAY: `Ça va`,
  GOOD: `Bien`,
  EXCELLENT: `Excellent`,
  DUPLICATE: `Dupliquer`,
  SEND: `Envoyer`,
  SELECT: `Sélectionner`,
  NOT_APPLICABLE_SHORT: `N/A`,
  NOT_APPLICABLE_PARENTHESIS: `(Non Applicable)`,
  TEXT_COMMA: ` ,`,
  AND: `et`,
  QUOTE: `"`,
  SEE_MORE: `Voir plus`,
  LOAD_MORE: `Charger plus…`,
  EXAMPLE: `Exemple`,
  PIXELS: `Pixels`,
  CHART: `Graphique`,
  TABLE: `Tableau`,
  CLICK_TOOLTIP_TO_ENLARGE: `Cliquez pour agrandir`,
  DECIMAL_POINT: `,`,
  MANUAL_INPUT: `Saisie manuelle`,
  INDICATOR_OF_MY_TEAM: `Indicateur de mon équipe`,
  INDICATOR_OF_OTHER_TEAM: `Indicateur d'une autre équipe`,
  N_MISSING_VALUES: `Pas de valeur manquante | 1 valeur manquante | {nb} valeurs manquantes`,
  BETA_TAG: `BETA`,
  CONTENT_BETWEEN_PARENTHESES: `({content})`,
  LOGIN_BY_TEAM: `Compte équipe`,
  LOGIN_BY_USER: `Compte utilisateur`,
  LOGIN_BY_SSO: `Compte Single Sign-On`,
  LOGIN_BY_TEAM_SHORT: `@:message.TEAM`,
  LOGIN_BY_USER_SHORT: `@:message.USER`,
  LOGIN_BY_SSO_SHORT: `Single Sign-On`,
  LOGIN_BY_SSO_HINT: `Entrez votre identifiant d'équipe si vous souhaitez vous connecter en tant qu'équipe OU votre nom d'utilisateur si vous souhaitez vous connecter à votre compte personnel.`,
  LOGIN_TEAM_ID: `Identifiant d'équipe`,
  LOGIN_TEAM_ID_EXAMPLE: `Identifiant d'équipe (Ex: "123456")`,
  LOGIN_USER_ID: `Nom d'utilisateur`,
  LOGIN_USER_ID_EXAMPLE: `Nom d'utilisateur (Ex: "h.dupont")`,
  LOGIN_PWD: `Mot de passe`,
  LOGIN__COMPANY_PWD: `Mot de passe de la société`,
  LOGIN_SUBMIT: `Se connecter`,
  STAY_CONNECTED: `Rester connecté`,
  FORGOT_PASSWORD: `Mot de passe oublié ?`,
  NEED_NEW_PWD: `Souhaitez-vous recevoir un nouveau mot de passe sur l'adresse email de votre équipe ?<br/>Le mot de passe sera modifié pour l'ensemble de l'équipe.<br/>Si votre équipe n'a pas configuré d'adresse email valide, le mot de passe sera envoyé à info@shizen.io.<br/><br/>Tous les utilisateurs connectés resteront connectés.`,
  NEED_NEW_PWD_USER: `Souhaitez-vous recevoir un nouveau mot de passe utilisateur ?<br/>Si aucune adresse email n'est configurée pour ce compte, le mot de passe sera envoyé sur l'adresse email de votre équipe.<br>Si celle-ci n'est pas configurée, le mot de passe sera envoyé à info@shizen.io.`,
  NEW_PWD_TEAM_ID: `Identifiant : (6 ou 7 chiffres)-(3 lettres) sans parenthèses`,
  NEW_PWD_USER_ID: `Entrez votre nom d'utilisateur`,
  PWD_RESET_SUCCESS: `Votre mot de passe a été réinitialisé. Vous le trouverez dans l'email qui vous a été envoyé.`,
  NEW_PWD_WRONG_FORMAT: `L'identifiant que vous avez entré ne correspond pas au format requis : L'identifiant est composé de 6 ou 7 chiffres suivis d'un tiret "-" puis de 3 caractères alphanumériques.<br/>Exemple : 100753-H7D`,
  NEW_PWD_NO_MATCH: `L'identifiant que vous avez entré ne correspond à aucun compte Shizen. Veuillez vérifier à nouveau.`,
  SEARCH_PLACEHOLDER: `Recherche...`,
  TYPE_IN_SEARCH_FIELD: `Écrivez quelque chose dans le champ de recherche`,
  SEARCHING_DOTS: `Recherche...`,
  NO_MATCH_PROBLEMS: `Aucun problème correspondant à la recherche`,
  NO_MATCH_ACTIONS: `Aucune action correspondant à la recherche`,
  NO_MATCH_GW: `Aucune tournée terrain correspondant à la recherche`,
  NO_MATCH_TEAMS: `Aucune équipe correspondant à la recherche`,
  SETTINGS: `Paramètres`,
  SETTINGS_SAML: `Paramètres d'authentification par SAML (SSO)`,
  SETTINGS_MAIN: `Paramètres généraux`,
  SETTINGS_INDICATORS: `Indicateurs`,
  SETTINGS_ACTIONS: `Actions`,
  SETTINGS_PROBLEMS: `Problèmes`,
  SETTINGS_INDICATORS_THEMES: `Indicateurs et thèmes`,
  SETTINGS_DASHBOARD: `Dashboard`,
  SETTINGS_MEETINGS: `Réunions`,
  SETTINGS_TEAM: `Détails d'équipe`,
  SETTINGS_GW: `@:message.GEMBA_WALKS`,
  SETTINGS_PAGES: `Pages des paramètres`,
  ADD_TYPE: `Ajouter un type`,
  DELETE_SUBTYPES: `Souhaitez-vous également supprimer les types que contient celui-ci ?`,
  CUSTOM_PROBLEM_HINTS: `Personnaliser les indications des champs d'un problème`,
  CUSTOM_PROBLEM_HINTS_EXPLANATION: `Vous pouvez personnaliser ici les indications suggérées en-dessous des champs de description d'un problème lors des remontées de problème.<br>Vous pouvez également choisir d'afficher ces indications dans la fiche problème.`,
  DISPLAY_PROBLEM_HINT_SHEET: `Afficher dans la fiche problème`,
  USE_COMPANY_SETTING: `Utiliser le paramètre de la société`,
  DEFAULT_HINTS: `Indications par défaut`,
  CUSTOM_PROBLEM_HINTS_HOWTO: `Remplissez les champs ci-dessous avec le texte que vous souhaitez voir apparaître en-desous des champs de remontée de problèmes. Si vous laissez un champ vide, l'indication par défaut sera alors affichée pour ce champ uniquement (les indications par défaut sont affichées ci-dessous).`,
  ENTER_IMPACT_HINT: `Entrer le texte à afficher`,
  DISPLAY_FULL_IMPACT_HINTS: `Afficher les indications en entier`,
  SETTINGS_PROBLEMS_MODE: `Mode par défaut`,
  DEFAULT_PROBLEM_MODE: `Mode de remontée de problème par défaut`,
  INFINITE_PB_BUG: `Un grand nombre de problèmes a été créé dans les dernières secondes.<br>Voulez-vous continuer à remonter des problèmes ?`,
  INFINITE_PB_BUG_RESUME: `La création de noveaux problèmes a été interrompue.<br>Souhiatez-vous créer de nouveaux problèmes ?`,
  SIMPLIFIED_MODE: `Mode simplifié`,
  ADVANCED_MODE: `Mode avancé`,
  SETTING_SAVED: `Paramètre enregistré`,
  THEME_LETTER: `Lettre`,
  INDIC_UNIT: `Unité`,
  INDIC_LIB_NAME: `(Bibliothèque : {name})`,
  MAXIMUM: `Maximum`,
  MAXIMUM_SHORT: `Max`,
  MAXIMUM_SHORT_N: `Max: {n}`,
  MINIMUM: `Minimum`,
  MINIMUM_SHORT: `Min`,
  ADD_INDICATOR: `Ajouter un indicateur`,
  ADD_THEME: `Ajouter un thème`,
  ADD_INDICATOR_FROM_LIBRARY: `Ajouter depuis la bibliothèque`,
  IMPORT_PUBLIC_INDICATOR: `Importer un indicateur public`,
  PUBLIC_INDIC_LETTER: `P`,
  INDIC_PUBLIC_FROM_OTHER_TEAM: `Cet indicateur est celui d'une autre équipe. Vous pouvez uniquement visualiser ses valeurs.`,
  DEFINE_MIN_MAX: `Définir une valeur maximale ou minimale`,
  DEFINE_VISUAL_TYPE: `Type de graphique`,
  CHART_TYPE: `Type de graphique`,
  CHART_LINE: `Courbe`,
  CHART_BAR: `Histogramme`,
  LINE: `Courbe`,
  BARS: `Bâtons`,
  PARETO: `Pareto`,
  SPECIFIC_SETTINGS: `Paramètres spéciaux`,
  SETTINGS_STATIC_VALUES: `Valeurs statiques`,
  SETTINGS_INCREMENTAL_VALUES: `Valeurs incrémentales`,
  SETTINGS_INCREMENT_NON_WD: `Incrémenter pendant les jours non ouvrables`,
  SETTINGS_PUBLIC: `Public`,
  SETTINGS_PUBLIC_INDIC: `Indicateur public`,
  SETTINGS_CALCULATED_INDIC: `Indicateur calculé`,
  BETA_CALCULATED_INDIC: `Vous pouvez dès à présent ajouter des indicateurs calculés à partir d'autres indicateurs sur votre dashboard.<br>N'hésitez pas à proposer des suggestions d'amélioration à l'aide du bouton en bas à droite de la page.`,
  SETTINGS_INDICATOR_CALC_EXPR: `Calcul`,
  SETTINGS_INDICATOR_CALC_SMALL_HINT: `Cliquez sur les boutons en-dessous du champ pour le remplir et créer votre calcul.`,
  SETTINGS_INDICATOR_CALC_HINT: `@:message.SETTINGS_INDICATOR_CALC_SMALL_HINT <br>L'option "@:message.MANUAL_INPUT" vous permet de laisser un champ vide à remplir chaque jour tandis que l'option "@:message.INDICATOR_OF_MY_TEAM" ajoute automatiquement la valeur de l'indicateur que vous choisirez dans le calcul.<br>\
Exemple: Pour calculer un taux entre deux indicateurs "Défauts" et "Pièces", cliquez sur 1, 0, 0, ×, puis "@:message.INDICATOR_OF_MY_TEAM", choisissez "Défauts", puis ÷, puis ajoutez l'indicateur "Pièces"`,
  SETTINGS_INDICATOR_CALC_EXPR_INVALID: `Calcul invalide`,
  SETTINGS_CALC_WRONG_PERIOD_UNIT: `Les indicateurs utilisés pour le calcul doivent avoir la même période pour un point du graphe.`,
  SETTINGS_CALC_INDIC_USED_PERIOD_UNIT: `Cet indicateur est utilisé dans le calcul de "{name}".<br>@:(message.SETTINGS_CALC_WRONG_PERIOD_UNIT).`,
  SETTINGS_INDIC_CALC_NOT_STATIC: `Les indicateurs statiques et incrémentaux ne peuvent pas faire l'objet d'un calcul.`,
  SETTINGS_INDIC_AVERAGE_AFTER_CALC: `Effectuer la moyenne après le calcul`,
  SETTINGS_INDIC_AVERAGE_AFTER_CALC_HINT: `Les valeurs seront divisées par le nombre de jours ouvrés.`,
  INDIC_SPEC_SETTINGS_HELP: `En choisissant "valeurs statiques", chaque fois que vous saisirez une valeur d'indicateur, elle restera la même chaque jour jusqu'à ce que vous ayez défini une nouvelle valeur.<br/><br/>\
  L'option "Valeurs incrémentales" fonctionne de la même manière, mais les valeurs augmentent du nombre que vous avez défini à côté de la case à cocher.<br/>Par défaut, les valeurs augmenteront durant les jours ouvrables uniquement mais vous pouvez choisir d'incrémenter les valeurs également pendant les jours non ouvrables.<br/><br/>\
  Les indicateurs publics peuvent être ajoutés aux tableaux des autres équipes. Ainsi, si vous cochez cette case, vous permettez à n'importe quelle équipe de votre société de voir les valeurs de cet indicateur.<br><br>\
  {gwHint}\
  Les valeurs d'un indicateur calculé sont déterminées à partir d'une expression mathématique que vous pouvez écrire après avoir coché la case.`,
  INDIC_INPUT_INTERVAL_SETTINGS: `Fréquence de saisie des valeurs`,
  INDIC_INPUT_SETTINGS_HELP: `Vous pouvez éditer la fréquence de saisie de cet indicateur.<br>Par exemple, en choisissant une période d'une semaine, vous ne pourrez plus avoir des valeurs de l'indicateur différentes chaque jour.<br>De plus, les valeurs de l'indicateur ne seront visibles que lorsque vous choisirez un mode de vue par semaine.`,
  INDIC_DISPLAY_WRONG_PERIOD: `Les valeurs de cet indicateur sont {what}. Vous devez changer l'affichage en cours.`,
  CHANGE_DISPLAY_INDIC_PERIOD: `Afficher des points {what}`,
  WEEKLY: `Hebdomadaire | Hebdomadaires`,
  MONTHLY: `Mensuel | Mensuels`,
  MONTHLY_FEM: `Mensuelle | Mensuelles`,
  OVER_LONGER_PERIOD: `Sur une plus longue période`,
  CUMULATE: `Cumuler les valeurs`,
  CALC_AVERAGE: `Calculer la moyenne`,
  INDICATORS_SAVED: `Indicateurs enregistrés`,
  CONFIRM_DELETE_INDICATOR: `Voulez-vous vraiment supprimer l'indicateur {0} ?`,
  CONFIRM_DELETE_THEME: `Voulez-vous vraiment supprimer le thème {0} ? Tous les indicaturs liés à ce thème seront également supprimés`,
  NO_INDICATOR: `Aucun indicateur`,
  INDIC_SETTINGS_OBJ_HINT: `(Objectif sur une période de {period})`,
  INDIC_SETTINGS_CHARTS_DISPLAY: `Affichage des graphes`,
  INDIC_SETTINGS_DISPLAY_VALUES: `Afficher la valeur des points`,
  INDIC_SETTINGS_DISPLAY_VALUES_HINT: `Affichez la valeur textuelle de chaque point du graphe à côté de celui-ci.`,
  INDIC_SETTINGS_DISPLAY_LABELS: `Afficher la date des points en abscisse`,
  INDIC_SETTINGS_DISPLAY_LABELS_HINT: `Affichez la date de chaque point du graphe si les points ne cumulent pas la valeur de plusieurs dates.`,
  INDIC_SETTINGS_NO_LABELS: `Ne pas afficher`,
  INDIC_SETTINGS_DISPLAY_LABEL_DATE: `Afficher la date`,
  INDIC_SETTINGS_DISPLAY_LABEL_CODE: `Afficher un code (L M M J V)`,
  INDIC_SETTINGS_DISPLAY_LABELS_RADIO_HINT: `En choisissant d'afficher un code, le graphe affichera L, M, M, J, V pour les jours de la semaine ; S1, S2, S3, pour les semaines ; et Jan., Fév., Mar. pour les mois.`,
  INDIC_SETTINGS_DISPLAY_PROBLEMS_IMPACT: `Afficher l'impact des problèmes dans les graphes`,
  INDIC_SETTINGS_DISPLAY_PROBLEMS_IMPACT_HINT: `Affichez l'impact des problèmes remontés et résolus sur les graphes des indicateurs pour identifier la conséquence réelle de ces problèmes sur les performances de l'équipe. Les graphiques afficheront un point rouge pour les problèmes remontés et un vert pour les problèmes résolus, la taille du point dépendant de l'impact des problèmes à cette date. Survolez le point avec la souris ou le doigt pour avoir plus de détails.`,
  INDIC_SETTINGS_THEME_IS_GW: `Ce thème d'indicateurs ne contient que des indicateurs de tournées terrain`,
  INDIC_SETTINGS_IS_GW: `Cet indicateur est un indicateur de tournées terrain`,
  INDIC_SETTINGS_GW_INDICATOR: `Indicateur de tournées terrain`,
  INDIC_SETTINGS_REGULAR_INDICATOR: `Indicateur classique`,
  INDIC_SETTINGS_REGULAR: `Classiques`,
  INDIC_SETTINGS_GW_HINT: `En cochant "@:message.INDIC_SETTINGS_GW_INDICATOR", vous précisez à Shizen que cet indicateur ne doit pas être affiché par défaut dans la liste des indicateurs de performance. De plus, vous pourrez utiliser cet indicateur lors de vos tournées terrain pour saisir une valeur numérique plutôt qu'un choix OK/NOK.`,
  INDIC_SETTINGS_GW_NEW_THEME_HINT: `Veuillez choisir le nouveau thème de cet indicateur.`,
  INDIC_SETTINGS_REGULAR_THEMES: `Thèmes d'indicateurs classiques`,
  INDIC_SETTINGS_GW_THEMES: `Thèmes d'indicateurs de tournées terrain`,
  INDIC_SETTINGS_GW_USAGE_NOT: `Cet indicateur n'est pas utilisé dans les modèles de tournées terrain.`,
  INDIC_SETTINGS_GW_USAGE: `Cet indicateur est utilisé {nTimes}.`,
  INDIC_SETTINGS_DELETE_THEME: `Supprimer le thème`,
  INDIC_SETTINGS_DELETE_INDIC: `Supprimer l'indicateur`,
  INDIC_SETTINGS_DELETE_ORPHAN_ITEMS: `{deleteWhat} et les éléments concernés dans les listes de vérification`,
  INDIC_SETTINGS_DISPLAY_CALC_COMMENTS: `Afficher les commentaires des indicateurs du calcul`,
  INDIC_SETTINGS_ADAPTATIVE_RANGE: `Afficher l'axe des ordonnées de sa plus basse à sa plus haute valeur`,
  MGT_COMPACT_DISPLAY_GW_INDICATORS: `Afficher les indicateurs de tournées terrain dans la vue compacte`,
  GW_INDICATORS_MOVED_TO_SETTINGS: `Vous pouvez maintenant paramétrer vos indicateurs depuis les paramètres.`,
  IW_TITLE: `Messages d'avertissement`,
  IW_NO_MSG_SET: `Aucun message paramétré.`,
  IW_SET_A_MSG: `Paramétrer un message`,
  IW_CUSTOM_MESSAGE: `Choisissez un message personnalisé pour cet indicateur`,
  IW_MSG_PH: `Message...`,
  IW_ALLOWED_OVERRUN: `Tolérance de dépassement de l'objectif`,
  IW_N_DAYS: `Durée de vie du message (en jours)`,
  IW_CONFIRM_DELETE: `Voulez-vous vraiment supprimer ce message ?`,
  IW_YOUVE_SETUP: `Vous avez paramétré un message d'avertissement pour cet indicateur :<br/><br/>{msg}`,
  IA_HINTS: `Conseils de l'assistant`,
  HIDE_HINTS: `Cacher les conseils de l'assistant`,
  INDIC_INPUT_DEFAULT_DATE: `Date de saisie d'indicateur`,
  INDIC_INPUT_DEFAULT_HINT: `Il s'agit de la date par défaut qui doit être sélectionnée lorsque vous cliquez sur le bouton "Saisie" de la page des indicateurs détaillés. Vous pouvez entrer ci-dessous le nombre de jours entre la date du jour et la date sélectionnée par défaut.`,
  NB_OF_DAYS: `Nombre de jours`,
  SIMPLIFIED: `Simplifiée`,
  ADVANCED: `Avancée`,
  PICTURES: `Images`,
  TAKE_PICTURE: `Prendre une photo`,
  DONE: `Terminé`,
  BROWSE_GALLERY: `Parcourir la galerie`,
  PICK_PICTURE: `Choisir une image`,
  PICK_PICTURE_CAMERA_GALLERY: `Cliquez sur ce bouton pour que l'appareil vous propose de choisir une image depuis l'appareil photo ou la galerie.`,
  VISUAL: `Visuel`,
  OPTIONAL: `Facultatif`,
  DESCRIPTION: `Description`,
  DESCRIPTION_PH: `Description...`,
  DESCRIPTION_PLACEHOLDER: `Décrivez l'action`,
  DESCRIBE_PROBLEM: `Décrivez le problème`,
  DEFINE_IMPACT: `Déterminez son impact`,
  LOCATE_PROBLEM: `Localisez le problème`,
  LOCATION: `Lieu`,
  LOCATION_AND_ACTIONS: `Lieu et actions`,
  CREATED_ON: `Créé le`,
  CREATED_BY: `Créé par`,
  WHO: `Qui`,
  WHAT: `Quoi`,
  WHERE: `Où`,
  WHEN: `Quand`,
  WHY: `Pourquoi`,
  HOW: `Comment`,
  HOW_MUCH: `Combien`,
  TYPE: `Type`,
  TYPES: `Types`,
  KEYWORDS: `Mots-clés`,
  IMPACT: `Impact`,
  DEADLINE: `Deadline`,
  STATE: `Statut`,
  LAST_MODIFIED_DATE: `Date de dernière modification`,
  ANALYSIS_STATE_DATE: `Date de début d'analyse`,
  PICTURES_TITLE: `Avez-vous des images du problème ?`,
  WHO_TITLE: `Qui est concerné ?`,
  WHAT_TITLE: `Que s'est-il passé ?`,
  WHERE_TITLE: `Où le problème est-il survenu ?`,
  WHEN_TITLE: `Quand est-ce arrivé ?`,
  WHY_TITLE: `Pourquoi est-ce un problème ?`,
  HOW_TITLE: `Comment est-ce arrivé ?`,
  HOW_MUCH_TITLE: `Peut-on le mesurer, quantifier ?`,
  TYPE_TITLE: `Quel est le type du problème ?`,
  LOCATION_TITLE: `Quels lieux sont concernés par ce problème ?`,
  INDICATORS_TITLE: `Le problème est-il lié à un indicateur ?`,
  KEYWORDS_TITLE: `Choisissez des mots-clés pour identifier ce problème`,
  IMPACT_TITLE: `Déterminez son impact`,
  DEADLINE_TITLE: `Quand doit-il être résolu ?`,
  SECURING_ACTIONS_TITLE: `Le problème doit-il être sécurisé rapidement ?`,
  NEXT: `Suivant`,
  NEX: `Suiv`,
  PREV: `Préc`,
  PROBLEM_SAVED: `Problème enregistré`,
  LEADER: `Responsable`,
  CATEGORIES: `Catégories`,
  UNIT: `Unité`,
  ORIGINAL_DEADLINE: `Deadline initiale`,
  ORIGINAL_DEADLINE_SHORT: `Initiale`,
  ACTION_WAS_POSTPONED_N: `L'action n'a jamais été reportée | Action reportée {n} fois | Action reportée {n} fois`,
  N_POSTPONEMENTS: `Aucun report | Un report | {n} reports`,
  REASON: `Motif`,
  REASON_PH: `@:message.REASON…`,
  STATE_POSTPONEMENT_REASON: `Vous pouvez entrer un nouveau motif de report<br>ou choisir un motif existant dans la liste.`,
  POSTPONEMENT_REASON_NO_PREV: `Aucun motif trouvé`,
  POSTPONEMENT_REASON: `Report du {date}`,
  POSTPONEMENTS_HISTORY: `Historique des reports`,
  NO_POSTPONEMENT_REASON: `Le motif du report n'a pas été spécifié.`,
  POSTPONEMENTS_NUMBER: `Nombre de reports`,
  POSTPONEMENTS_REASON: `Motifs des reports`,
  PICK_A_PB: `Choisissez un problème`,
  AC_NOT_LINKED_PB: `Cette action n'est pas rattachée à un problème`,
  AC_NOT_LINKED_CAUSE: `Cette action n'est pas rattachée à une cause`,
  SECURING_ACTION: `Action de sécurisation`,
  SECURING_ACTIONS: `Actions de sécurisation`,
  DISPLAY_ONGOING_SECURING_ACTIONS: `Afficher les actions de sécurisation en cours`,
  QUICK_ACTIONS: `Actions rapides`,
  LANDSCAPE_DISPLAY: `Afficher les plans d'actions horizontalement`,
  SECU_STATE_PENDING: `Actions de sécurisation en attente`,
  SECU_STATE_ONGOING: `Actions de sécurisation en cours`,
  SECU_STATE_COMPLETED: `Actions de sécurisation terminées`,
  SAVE_BACK: `Enregistrer et revenir à la page précédente`,
  SAVE_SHEET: `Enregistrer et aller à la fiche problème`,
  SAVE: `Enregistrer`,
  SAVED: `Enregistré`,
  SETTINGS_SAVED: `Paramètres enregistrés`,
  CONNECTION_ERROR: `Une erreur est survenue, nous vous prions de réessayer ultérieurement.`,
  INDICATOR_MISSING: `Cet indicateur n'existe pas ou a été supprimé. Vous pouvez modifier ou supprimer cette étape depuis les paramètres de réunions.`,
  WRONG_CREDENTIALS: `Veuillez vérifier l'identifiant et le mot de passe.`,
  LOGIN_SSO_NOT_ENABLED: `La connexion par SSO n'est pas configurée sur ce compte.`,
  LOGIN_LAST_ATTEMPT_TOO_CLOSE: `Un délai de 2 secondes est nécessaire après un échec de connexion. Veuillez réessayer.`,
  LOGIN_LOCKED_AFTER_FAILED_LOGIN: `Ce compte a été verrouillé à la suite de multiples tentatives de connexion erronées.`,
  LOGIN_LOCK_ON_NEXT_FAIL: `Attention : Si vous entrez à nouveau un mot de passe erroné, le compte risque d'être verrouillé, et vous ne pourrez plus vous y connecter.`,
  LEAVING_CHANGES_BEHIND: `Il y a des changements non enregistrés sur cette page.`,
  EXIT_WITHOUT_SAVING: `Quitter sans enregistrer`,
  SAVE_AND_EXIT: `Enregistrer et quitter`,
  EXIT: `Quitter`,
  LEAVE_WARNING: `Vous allez quitter cette page. Toutes les données non enregistrées seront perdues.`,
  CONTINUE: `Continuer`,
  ENTRY_DATE: `Date de saisie`,
  IN_PROGRESS: `En cours`,
  ENDED: `Terminé`,
  REMOVE: `Supprimer`,
  ARCHIVE: `Archiver`,
  PROBLEM_DELETED: `Problème supprimé`,
  PROBLEM_ARCHIVED: `Problème archivé`,
  PROBLEM_RESTORED: `Problème restauré`,
  EXPORT_TO_EXCEL: `Exporter au format excel`,
  PB_EXPORT_ALL: `Exportez la liste des problèmes au format excel.`,
  ACTION_EXPORT_ALL: `Exportez la liste des actions au format excel.`,
  ARCHIVED_THIS_WEEK: `Archivé cette semaine ?`,
  ARCHIVE_DATE: `Date d'archivage`,
  WORK_START_DATE: `Date de mise dans un plan d'action`,
  FIRST_ACTION_WORK_DATE: `Date de la première action dans un plan`,
  ACT_DATE: `Date de passage en "Act"`,
  ACTIONS_PROBLEM_WHAT: `"Quoi" du problème`,
  ACTION_STATE_PENDING: `En attente`,
  ACTION_STATE_ONGOING: `En cours`,
  ACTION_STATE_COMPLETED: `Terminée`,
  PB_STATES: [
    `En attente d'analyse`,
    `Analyse en cours`,
    `Actions en cours`,
    `Actions terminées`,
  ],
  DISPLAY_NUMBER_OF_ACTIONS_PENDING: `Afficher le nombre d'actions en attente sur le menu de navigation.`,
  ACTIONS_COMPLETION_DATE: `Date de clôture des actions`,
  COMPLETED_ACTIONS: `Actions terminées`,
  ONGOING_ACTIONS: `Actions en cours`,
  PENDING_ACTIONS: `Actions en attente`,
  PENDING_PROBLEMS_: `Pas de problème en attente|Un problème en attente|{n} problèmes en attente`,
  COMPLETED_ACTIONS_: `Pas d'action terminée|Une action terminée|{n} actions terminées`,
  CAUSE_NOT_VERIFIED: `Cause non vérifiée`,
  CAUSE_VERIFIED: `Cause vérifiée`,
  CAUSE_VERIFIED_REAL: `Cause réelle`,
  CAUSE_VERIFIED_NOT_REAL: `Cause fausse`,
  ADD_A_CAUSE: `Ajouter une cause`,
  CAUSE_SUGGESTION: `Suggestion de cause`,
  ADD_AN_ACTION: `Ajouter une action`,
  ACTION_SUGGESTION: `Suggestions d'action`,
  ADD_SECURING_ACTION: `Ajouter une action de sécurisation`,
  NEW_ACTION: `Nouvelle action`,
  ADD_A_COMMENT: `Ajouter un commentaire`,
  CONFIRM_DELETE_COMMENT: `Supprimer ce commentaire ? (Cette action est irréversible)`,
  COMMENT_SAVED: `Commentaire enregistré`,
  COMMENT_OF: `Commentaires de "{currentChecklistItemName}"`,
  HOW_ADD_PICTURE: `De quelle manière souhaitez-vous ajouter une image ?`,
  NO_LEADER: `Aucun responsable`,
  AFFECT_TEAM_NO_LEADER: `Équipe {team} (Aucun responsable)`,
  GAIN: `Gain`,
  GAIN_UNIT_DEFAULT: `€`,
  DEFINE_GAIN: `Définir un gain`,
  COMMENTS: `Commentaires`,
  INDICATORS_AND_COMMENTS: `Indicateurs et commentaires`,
  CLICK_TO_TYPE: `Cliquez ici pour écrire...`,
  CLICK_TO_CHANGE: `Cliquez ici pour modifier...`,
  COMMENT_PLACEHOLDER: `Ajouter des commentaires à l'action`,
  ACTION_LEADER_HISTORY: `Historique du responsable de l'action`,
  ACTION_CREATED_BY: `Action créée par {name}`,
  ACTION_ASSIGNED_TEAMS: `L'équipe "{fromTeamName}" a envoyé cette action à "{toTeamName}"`,
  ACTION_RETURNED_TEAMS: `L'équipe "{toTeamName}" a renvoyé cette action à "{fromTeamName}"`,
  ACTION_LEADER_CHANGED: `L'équipe "{teamName}" a assigné cette action à {toUser} ({toTeamName})`,
  RETURN_ACTION: `Renvoyer l'action`,
  ACTION_RETURNED: `Action renvoyée`,
  ACTION_PENDING: `En attente`,
  EDIT: `Éditer`,
  EDIT_PB: `Modifier le problème`,
  EDIT_PICTURES: `Modifier les images`,
  PICTURES_UPDATED: `Images mises à jour`,
  CAUSE_SELECT: `Sélectionner la cause`,
  CAUSE_UNSELECT: `Désélectionner la cause`,
  CAUSE_DELETE: `Supprimer`,
  CAUSE_DELETE_CONFIRM: `Voulez-vous vraiment supprimer cette cause ? <br/>Les actions et images associées seront également supprimées`,
  LATEST_PROBLEMS: `Derniers problèmes remontés`,
  OTHER_PROBLEMS: `Autres problèmes`,
  SORT_BY_IMPACT: `Par impact`,
  SORT_BY_PROBLEM: `Par problème`,
  SORT_BY_ENTRY_DATE: `Par date de saisie`,
  SORT_BY_ADD_IN_ACTION_PLAN_DATE: `Par date d'ajout`,
  SORT_BY_DEADLINE: `Par deadline`,
  SORT_BY_SHEET_LAST_MODIFIED: `Par dernière mise à jour de la fiche`,
  SORT_BY_TITLE: `Par titre (A-Z)`,
  SORT_BY_ARCHIVE_DATE: `Par date d'archivage`,
  ALL: `Tout`,
  ALLS: `Tous`,
  UNASSIGNED: `Non affectés`,
  UNASSIGNED_FEM: `Non affectées`,
  UNSPECIFIED: `Non spécifié`,
  ACTION_PLAN: `Plan d'action`,
  NEW_ACTION_PLAN: `Nouveau plan d'action`,
  ADD_ACTION_PLAN: `Ajouter un plan d'action`,
  ACTION_PLAN_MAX_ACTIONS: `Nombre d'actions maximum`,
  ACTION_PLAN_DURATION: `Durée par défaut d'une action`,
  DURATION: `Durée`,
  DURATION_BEFORE: `avant`,
  TWENTY_FOUR_HOURS: `24h`,
  HOURS: `Heure | Heure | Heures`,
  MINUTES: `Minute | Minute | Minutes`,
  SECONDS: `Seconde | Seconde | Secondes`,
  DAYS: `Jour | Jour | Jours`,
  WEEKS: `Semaine | Semaine | Semaines`,
  MONTHS: `Mois`,
  N_TIMES: `0 fois | 1 fois | {nb} fois`,
  N_SECONDS: `0 seconde | 1 seconde | {nb} secondes`,
  N_HOURS: `0 heure | 1 heure | {nb} heures`,
  N_DAYS: `0 jour | 1 jour | {nb} jours`,
  N_WEEKS: `0 semaine | 1 semaine | {nb} semaines`,
  N_MONTHS: `0 mois | 1 mois | {nb} mois`,
  EDIT_INDIC_VALUES: `Modifier les valeurs des indicateurs`,
  STOP_EDIT_INDIC_VALUES: `Fin de la modification`,
  HIDE_SOME_INDICATORS: `Cacher certains indicateurs`,
  N_HIDDEN_INDICATORS: `Aucun | 1 indicateur caché | {nb} indicateurs cachés`,
  HIDE_INDICATORS_HINT: `Vous pouvez choisir de cacher un ou plusieurs indicateurs. Cela peut notamment vous être utile lorsque vous souhaitez afficher uniquement des indicateurs court-terme ou moyen-terme.`,
  GROUPED_SELECTION: `Sélection groupée`,
  SUPPORT_CHECKBOX: `Plan support (Déplacer des actions dans ce plan pour les affecter à une autre équipe)`,
  ACTION_PLANS_SAVED: `Plans d'action enregistrés`,
  SAVE_ACTION_PLANS: `Enregistrer les plans d'action`,
  DELETE_ACTION_PLAN_CONFIRM: `Voulez-vous vraiment supprimer ce plan d'action ? <br/>Cette action est irréversible.<br/><br/>Les actions qui y sont affectées seront à nouveau en attente.`,
  DELETE_ACTION_PLAN: `Supprimer le plan d'action`,
  ACTION_PLAN_DELETED: `Plan d'action supprimé`,
  CANT_EDIT_SUPPORT_WITH_ACTIONS: `Vous ne pouvez pas modifier un plan d'action support lorsqu'il contient des actions d'une autre équipe.`,
  CANT_EDIT_PLAN_TYPE: `Vous ne pouvez pas changer le type d'un plan lorsqu'il contient des actions.`,
  PLAN_DROP_HELP: `Glissez une action ici pour l'ajouter au plan`,
  ASSIGN_TO_PLAN_CONFIRM: `Voulez-vous affecter l'action "{actionName}" au plan "{planName}" ?`,
  ASSIGN_ACTION: `Affecter l'action`,
  ASSIGN_TO_PLAN_IS_QUICK: `Cette action est une action rapide. Elle ne peut donc pas être ajoutée à un plan spécifique.<br>En revanche, vous pouvez définir cette action comme étant "en cours". Elle apparaîtra dans la colonne "@:message.QUICK_ACTIONS" ou "@:message.SECURING_ACTIONS" dans la page Actions.`,
  SET_ACTION_ONGOING: `Mettre cette action "en cours"`,
  ACTION_MAYBE_IN_OTHER_PLAN: `Une erreur est survenue, l'action est peut-être déjà affectée à un autre plan.`,
  REFRESHING_AVAILABLE_TEAMS: `Mise à jour des équipes`,
  CHOOSE_SUPP_TEAM: `Veuillez choisir l'équipe support`,
  ACTION_ASSIGNED: `Action affectée`,
  PLAN_FULL: `Ce plan d'action semble plein. Vous pouvez affecter cette action à un autre plan ou supprimer des actions du plan.`,
  ONLY_PLAN_OWNER_ASSIGN: `Seule l'équipe propriétaire du plan peut y affecter des actions`,
  CANT_ASSIGN_SELF: `Cette action est déjà affectée à votre équipe.`,
  CONFIRM_ASSIGN_SAME_SUPPORT: `Vous essayez d'envoyer cette action à l'équipe qui vous l'a assignée en premier lieu.<br/>Si vous voulez retourner l'action, vous pouvez le faire en cliquant sur le bouton "Renvoyer" sur la page de l'action.<br/><br/>Voulez-vous vraiment assigner l'action à cette équipe ?`,
  PROBLEM_SHEET: `Fiche problème`,
  ACTION_SHEET: `Fiche action`,
  SUPPORT_LETTER: `S`,
  ACTION_FROM_OTHER_TEAM: `Cette action vous a été assignée par une autre équipe.`,
  PROBLEM_FROM_GW: `Ce problème a été remonté pendant une tournée terrain`,
  CANT_DELETE_BUT_RETURN: `Vous ne pouvez pas la supprimer, mais vous pouvez leur renvoyer.`,
  TEAM_ACTIONS: `Actions de l'équipe`,
  ACTIONS_RECEIVED: `Actions reçues`,
  REMOVE_FROM_PLAN: `Retirer cette action du plan d'action (En attente)`,
  REMOVE_FROM_PLAN_CONFIRM: `Voulez-vous remettre cette action en attente ?`,
  REMOVE_ACTION: `Retirer l'action`,
  ACTION_REMOVED: `Action retirée`,
  ACTION_COMPLETED: `Action terminée`,
  ACTION_COMPLETED_CONFIRM: `Cette action est-elle terminée ?`,
  COMPLETE_ACTION: `Clôturer et archiver`,
  RESTORE_ACTION: `Revoir l'action`,
  ALL_A_ACTION_COMPLETED: `Archiver toutes les actions terminées`,
  ALL_A_ACTION_COMPLETED_CONFIRM: `@:message.ALL_A_ACTION_COMPLETED ?`,
  CONFIRM_DELETE_ACTION: `Êtes-vous sûr(e) de vouloir supprimer cette action ?<br/>Cette action est irréversible.`,
  DELETE_ACTION: `Supprimer cette action`,
  ACTION_DELETABLE_ASSIGNED: `Cette action ne peut être supprimée que par l'équipe affectée.`,
  ACTION_DELETED: `Action supprimée`,
  ACTION_RESPONSIBILITY_OTHER_TEAM: `Cette action est sous la responsabilité d'une autre équipe et vous n'y avez pas accès.`,
  CONFIRM_DELETE_PB: `Êtes-vous sûr(e) de vouloir supprimer ce problème ?<br/>Cette action est irréversible.`,
  CONFIRM_ARCHIVE_PB: `Êtes-vous sûr(e) de vouloir archiver ce problème ?<br/>Vous pourrez le restaurer depuis la page des archives.`,
  DEFAULT_PERIOD: `Période par défault`,
  ONE_DAY: `1 jour`,
  SEVEN_DAYS: `7 jours`,
  FOUR_WEEKS: `4 sem.`,
  TWELVE_MONTHS: `12 mois`,
  SEVEN_DAYS_SHORT: `7 j.`,
  FOUR_WEEKS_SHORT: `4 s.`,
  TWELVE_MONTHS_SHORT: `12 m.`,
  PERIOD: `Période`,
  LOADING: `Chargement`,
  LOADING_DOTS: `Chargement...`,
  BACK: `Retour`,
  INPUT: `Saisie`,
  DISPLAY: `Afficher`,
  DONT_DISPLAY: `Ne pas afficher`,
  DISPLAY_NOUN: `Affichage`,
  DISPLAY_VALUES: `Afficher les valeurs`,
  CUSTOM_DISPLAY: `Affichage personnalisé`,
  ENTER_A_NUMBER: `Veuillez entrer une valeur`,
  INDIC_VALUE_HINT_SAVED: `Cette valeur a été enregistrée`,
  INDIC_VALUE_HINT_NOT_SAVED: `Cette valeur n'est pas enregistrée`,
  INDICATOR_VALUE_SAVED: `Valeur de l'indicateur enregistrée`,
  INDIC_VALUE_BEFORE_COMMENT: `Vous devez entrer une valeur si vous souhaitez ajouter un commentaire.`,
  CONFIRM_DELETE_INDIC_VAL: `Souhaitez-vous vraiment supprimer cette valeur ?<br/>Le commentaire associé sera également supprimé.`,
  INDICATOR_VALUE_DELETED: `Valeur supprimée`,
  N_VALUES: `0 valeur|1 valeur|{nb} valeurs`,
  INDIC_COMMENT_NEED_VALUE: `Vous devez entrer une valeur pour l'indicateur avant d'entrer un commentaire.`,
  CANT_EDIT_PUBLIC_INDIC: `Vous ne pouvez pas modifier cet indicateur, il appartient à une autre équipe.`,
  INDICATOR_OBJECTIVE_SAVED: `Objectif enregistré`,
  NO_ACCESS: `Votre équipe n'a pas accès à ce contenu`,
  SETTINGS_DISPLAY_CURRENT_INFOS: `Afficher les informations récentes`,
  CRITICAL_PROBLEMS: `Problèmes critiques`,
  LOWEST_POSSIBLE_IMPACT: `Impact minimal des problèmes affichés dans le dashboard`,
  ELAPSED_DAYS_SINCE_REPORT: `Nombre de jours depuis leur remontée`,
  DEFAULT_DB_INDIC_VIEW: `Vue par défaut des indicateurs`,
  N_DB_ACTIONS_LINES: `Nombre de lignes à afficher pour une action`,
  DISPLAY_GAIN: `Afficher le champ "Gain"`,
  MEETINGS_ADD_INFO: `Informations supplémentaires pendant les réunions`,
  HIDE_INFO_GW: `Cacher les informations sur les prochaines tournées terrain`,
  HIDE_INFO_SUGGESTIONS: `Cacher les suggestions dans la page d'informations`,
  MEETINGS_PLANNINGS: `Planifications des réunions`,
  PLANNINGS: `Planifications`,
  PLANNING: `Planning`,
  ADD_PLANNING: `Ajouter une planification`,
  DELETE_PLANNING_CONFIRM: `Souhaitez-vous supprimer cette planification ?`,
  PLANNINGS_SAVED: `Réunions enregistrées`,
  PLANNING_DELETED: `Réunion supprimée`,
  NEW_MEETING: `Nouvelle réunion`,
  MEETING_NAME: `Nom de la réunion`,
  MEETING_ROLES: `Rôles`,
  MEETING_NO_ROLES: `Les rôles n'ont pas encore été assignés`,
  REPEATABILITY: `Répétitions`,
  EVERY_DAY: `Tous les jours`,
  EVERY_WEEK: `Toutes les semaines`,
  EVERY_MONTH: `Tous les mois`,
  APPLY_TIME_PLANNING: `Appliquer aux autres jours`,
  ONCE: `Une fois`,
  DAY: `Jour`,
  DAY_OF_MONTH: `Jour du mois`,
  TIME: `Horaire`,
  MONDAY: `Lundi`,
  TUESDAY: `Mardi`,
  WEDNESDAY: `Mercredi`,
  THURSDAY: `Jeudi`,
  FRIDAY: `Vendredi`,
  SATURDAY: `Samedi`,
  SUNDAY: `Dimanche`,
  DATE_SWITCHER_DISABLED: `Ces flèches servent à changer la période d'affichage des indicateurs. Lorsque vous modifiez les valeurs, utilisez les flèches à côté des valeurs des indicateurs.`,
  STEP: `Étape`,
  STEPS: `Étapes`,
  ADD_STEP: `Ajouter une étape`,
  STEP_NB: `Étape n° {stepNumber}`,
  STEP_MIN_DURATION: `Minimum : {stepDuration}`,
  SEE_PAGE: `Voir la page`,
  MGT_INDICATORS: `Indicateurs du management`,
  STATS_FROM_MGT: `Statistiques du management`,
  SAFETY_SECTION: `Point sécurité`,
  LINKS_TO_PAGE: `Envoie à la page`,
  CHOOSE_SETTINGS: `Choisir les paramètres`,
  DETAILED_INDICATOR: `Indicateur détaillé`,
  INDICATOR_INPUT: `Saisie d'indicateur`,
  MEETING_PAGES: `Pages de réunion`,
  MAIN_PAGES: `Pages principales`,
  MGT_PAGES: `Pages du management`,
  MEETING_END: `Fin de la réunion`,
  START: `Démarrer`,
  STARTING: `Démarrage...`,
  END: `Fin`,
  PARTICIPANTS: `Participants`,
  ADD_PARTICIPANTS: `Ajouter des participants`,
  START_MEETING: `Démarrer la réunion`,
  MEETING_END_CONFIRM: `Souhaitez-vous terminer la réunion ?`,
  MEETING_ENDED: `Réunion terminée`,
  MEETING_LEAVE_CONFIRM: `Souhaitez-vous quitter la réunion ?`,
  MEETING_LEAVE: `Quitter la réunion`,
  MEETING_STARTED_JOIN: `Une réunion a démarré. Souhaitez-vous la rejoindre ?`,
  JOIN_MEETING: `Rejoindre`,
  DONT_JOIN_MEETING: `Ne pas rejoindre`,
  MEETING_OVER: `La réunion est terminée`,
  MEETING_REMOTELY_CLOSED: `La réunion est terminée`,
  ERROR_SAME_MEETING: `Vous participez déjà à cette réunion`,
  NOTICE_LEAVE_MEETING: `En effectuant cette action, vous quitterez la réunion en cours.`,
  MT_CURRENT_PAGE: `Aller à la page en cours`,
  MEMBERS: `Membres`,
  FIRST_NAME: `Prénom`,
  LAST_NAME: `Nom`,
  ID: `ID`,
  USERNAME: `Nom d'utilisateur`,
  LOCATION_CLICK_HINT: `Cliquer pour choisir un lieu`,
  WORKING_HOURS: `Horaires de travail`,
  DAY_START: `Début de la journée`,
  DAY_END: `Fin de la journée`,
  SEEK_ROOT_CAUSES: `Rechercher les causes racines`,
  FIVE_WHYS: `5 Pourquoi`,
  ISHIKAWA: `Ishikawa`,
  SHOW_ALL_ACTIONS: `Voir toutes les actions du problème`,
  CAUSE_SAVED: `Cause enregistrée`,
  CONFIRM_DELETE_FW_CAUSE: `Êtes-vous sûr(e) de vouloir supprimer cette cause ?<br/>Toutes les causes qui en dépendent seront supprimées également.<br/><br/>Cette action est irréversible.`,
  CAUSE_DELETED: `Cause supprimée`,
  DISPLAY_IN_SHEET: `Afficher dans la fiche problème`,
  DISPLAY_IN_SHEET_SHORT: `Aff. dans la fiche`,
  HIDE: `Cacher`,
  SELECT_ROOT_CAUSES: `Sélectionnez les causes à afficher dans la fiche problème`,
  CONFIRM_DELETE_STICKER: `Supprimer l'étiquette ? Cette action est irréversible.`,
  SUGGESTIONS: `Suggestions`,
  SUGGESTION: `Suggestion`,
  ADD_A_SUGGESTION: `Nouvelle suggestion`,
  MAIN_MENU: `Général`,
  TEAMS_MANAGEMENT: `Management`,
  CURRENT_INFOS: `Informations en cours`,
  NEW_INFO: `Nouvelle information`,
  MANAGER_TEAMS_TITLE: `Équipes de {manager}`,
  NO_TEAMS: `Aucune équipe`,
  SELECT_CHILDREN_TEAMS: `Sélectionner les équipes supervisées`,
  SELECT_CHILDREN_TEAMS_SHORT: `Sél. supervisées`,
  SELECT_BY_HIERARCHY: `Sélect. par niv. hiérarchique`,
  SELECT_ALL_LVL: `Niveau {lvl}`,
  NO_ACCESS_TO_TEAM: `Vous n'avez pas accès à cette équipe`,
  SELECTED_TEAMS: `Équipes sélectionnées`,
  INFO_RELEASE_DATE: `Date de diffusion`,
  CREATION_DATE: `Date de création`,
  INFO_REMOVAL_DATE: `Date de fin`,
  RELEASE_INFO: `Diffuser`,
  DEFAULT_DISPLAY: `Affichage par défaut`,
  INFO_SAVED: `Information enregistrée`,
  NO_TEAMS_SELECTED: `Aucune équipe sélectionnée`,
  N_TEAMS_SELECTED: `Aucune équipe sélectionnée|1 équipe sélectionnée|{nb} équipes sélectionnées`,
  N_TEAMS_SELECTED_NAMES: `@:message.N_TEAMS_SELECTED ({teamNames})`,
  INFO_MESSAGE: `Message d'information`,
  INFO_DELETE_CONFIRM: `Supprimer cette information ? (Cette action est irréversible)`,
  INFO_DELETE: `Supprimer`,
  INFO_DELETED: `Information supprimée`,
  INFO_FW: `Transférer`,
  INFO_FW_PICK_TEAM: `Choisissez au moins une équipe à laquelle vous souhaitez transmettre cette information.`,
  INFO_UPCOMING_GW: `La tournée terrain "{name}" aura lieu aux dates suivantes : {dates}`,
  ADDITIONAL_INFO: `Informations annexes`,
  INFO_RELATED_GW: `Tournée terrain associée`,
  INFO_DISABLED_HINT_GW: `Cette information ne peut pas être modifiée car c'est un résumé d'une tournée terrain.`,
  INFO_DISABLED_HINT_OTHER_TEAM: `Cette information ne peut pas être modifiée car elle a été créée par une autre équipe.`,
  RECIPIENTS: `Destinataires`,
  NB_REPORTED_PB: `{nb} remonté | {nb} remonté | {nb} remontés`,
  NB_COMPLETED_PB: `{nb} terminé | {nb} terminé | {nb} terminés`,
  ONGOING_PROBLEMS: `Problèmes en cours`,
  MONTH: `Mois`,
  WEEK: `Semaine`,
  TODAY: `Aujourd'hui`,
  TODAY_SHORT: `Auj.`,
  YESTERDAY: `Hier`,
  TEAMS_ACTIONS: `Actions des équipes`,
  NB_LATE_ACTIONS: `dont {nb} en retard`,
  QUICK_ACTION: `Action rapide`,
  PDCA: `PDCA`,
  PDCA_BEFORE_P: `Att.`,
  PDCA_PLAN: `Plan`,
  PDCA_DO: `Do`,
  PDCA_CHECK: `Check`,
  PDCA_ACT: `Act`,
  PDCA_ACT_ARCHIVED: `Act (archivée)`,
  PDCA_P: `P`,
  PDCA_D: `D`,
  PDCA_C: `C`,
  PDCA_A: `A`,
  PDCA_MUST_BE_IN_PLAN: `Placez l'action dans un plan pour modifier son étape`,
  LATE_ACTIONS: `Actions en retard`,
  LATEST_NEWS: `Informations récentes`,
  FROM_TEAM: `De l'équipe "{team}"`,
  FROM_YOUR_TEAM: `De votre équipe`,
  UPCOMING_INFOS: `À venir`,
  INFOS_N_MEETING_SUGG: `Aucune suggestion à cette réunion|Une suggestion pour cette réunion|{n} suggestions pour cette réunion`,
  TEAM_INFOS_SHORT: `Reçues`,
  SENT_INFOS_SHORT: `Envoyées`,
  OUR_TEAM: `Notre équipe`,
  TEAM_INFOS: `Nos informations pour cette équipe`,
  SENT_INFOS: `Les informations envoyées par cette équipe`,
  INFO_DISPLAY_FULL_INFO: `Afficher les informations en entier`,
  VISUAL_MODE: `Vue`,
  TEMPLATE: `Modèle`,
  COMPACT: `Compacte`,
  CUMUL: `Cumul.`,
  OVER_PERIOD_FROM_TO: `Sur la période du {start} au {end}`,
  AVERAGE_GAP_TO_THE_GOAL: `Moyenne des écarts aux objectifs par équipe`,
  TEAM_AVERAGE_GAP: `L'équipe "{team}" est en écart moyen de {gap}{percStr} par rapport à l'objectif sur cette période.`,
  TEAM_VALUES_OK_OBJECIVE: `Sur cette période, l'équipe "{team}" a des valeurs en accord avec ses objectifs`,
  MGT_SELECTED_INDICATORS: `Indicateurs sélectionnés ({n})`,
  N_EMPTY_VALUES: `Aucune valeur non renseignée|1 valeur non renseignée|{nb} valeurs non renseignées`,
  N_VALUES_OUTSIDE: `Aucune valeur en écart par rapport à l'objectif|1 valeur en écart par rapport à l'objectif|{nb} valeurs en écart par rapport à l'objectif`,
  N_VALUES_COMPLY: `Aucune valeur ne correspond à l'objectif|1 valeur correspond à l'objectif|{nb} valeurs correspondent à l'objectif`,
  PICTURES_FROM_PROBLEMS: `Images des problèmes`,
  CURRENT_PICTURES: `Images actuelles`,
  FROM_DEVICE: `Depuis l'appareil`,
  PICTURES_FROM_SLEAN: `Images de Shizen`,
  CLICK_TO_EDIT: `Cliquer ici pour éditer`,
  CONFIRM_REMOVE_STEP: `Supprimer cette étape ?`,
  CUSTOM_PAGE: `Page personnalisable`,
  CUSTOM_TEXT_PH: `Texte personnalisé...`,
  REPORTED_PB_NUMBER: `Nombre de problèmes remontés`,
  ONGOING_PB_NUMBER: `Nombre de problèmes en cours`,
  COMPLETED_PB_NUMBER: `Nombre de problèmes résolus`,
  PROBLEM_DISTRIBUTION_TYPE: `Répartition des problèmes par type`,
  REPORTED_ACTIONS_NUMBER: `Nombre d'actions créées`,
  ONGOING_ACTIONS_NUMBER: `Nombre d'actions en cours`,
  COMPLETED_ACTIONS_NUMBER: `Nombre d'actions terminées`,
  ACTIONS_POSTPONED: `Nombre de reports d'actions`,
  REPORTED_GW_PB_NUMBER: `Problèmes issus des tournées terrain`,
  REPORTED_GW_ACTIONS_NUMBER: `Actions issues des tournées terrain`,
  PROBLEM_DISTRIBUTION_INDICS: `Répartition des problèmes par indicateur`,
  PROBLEM_RECURRENCE_BREAKDOWN: `Répartition de la récurrence des problèmes`,
  MEETING_RATING_DISTRIBUTION: `Répartition des réunions par note`,
  PICTURE_SAVED: `Image enregistrée`,
  MEETING_STARTED_RESUME: `Une réunion "{name}" a démarré il y a quelques minutes sur cet appareil.<br/>Reprendre la réunion ?`,
  RESUME: `Reprendre`,
  DISCARD_MEETING: `Abandonner`,
  IA_HELP: `Un coup de main ?`,
  IA_ANALYSIS: `Analyse`,
  IA_ANALYSIS_TEXT: `Souhaitez-vous obtenir une analyse ?`,
  ANALYSING: `Analyse en cours...`,
  VALUE: `Valeur`,
  OBJECTIVE: `Objectif`,
  OBJECTIVE_SHORT: `Obj.`,
  MAX_OBJECTIVE: `Max : {objective}`,
  MIN_OBJECTIVE: `Min : {objective}`,
  OUTSIDE_OBJECTIVE: `{out} / {in} valeurs hors de l'objectif.`,
  OUTSIDE_OBJECTIVE_10_DAYS: `{out} valeurs hors de l'objectif ces 10 derniers jours.`,
  WHAT_DO_BACK_OBJECTIVE: `Quelles actions peuvent être mises en place rapidement pour revenir à l'objectif ?`,
  NB_DAYS_IN_A_ROW_OUTSIDE: `{nb} jours d'affilée avec une valeur hors objectif du {fromDate} au {toDate}.`,
  WHY_OUTSIDE_OBJECTIVE: `Pourquoi l'indicateur est hors objectif ?`,
  IS_OBJECTIVE_RIGHT: `L'objectif est-il correct ?`,
  IS_OBJECTIVE_AMBITIOUS: `Est-il trop ambitieux ?`,
  NEED_LINKED_PROBLEM: `Y a-t-il un problème critique en lien avec cet indicateur ?`,
  N_INDIC_ISSUES_FOUND: `Je n'ai pas trouvé de problème particulier sur ces indicateurs.|J'ai trouvé un indicateur qui nécessite votre attention.|J'ai trouvé {nb} indicateurs nécessitant votre attention.`,
  INDIC_ISSUES_CHECK_OUT: `Vous devriez peut-être aller voir.`,
  INDIC_LONGEST_STRAIGHT_OUTSIDE: `Au moins un indicateur avec {nb} valeurs d'affilée hors de l'objectif.`,
  NO_PROBLEMS: `Aucun problème`,
  NO_COMPLETED_PROBLEMS: `Aucun problème terminé`,
  NO_COMPLETED_ACTIONS: `Aucune action terminée`,
  NO_CRITICAL_PROBLEM: `Aucun problème critique ces derniers jours.`,
  IS_IMPACT_CORRECTLY_SET: `L'impact des problèmes est-il correctement saisi ?`,
  N_CRITICAL_PROBLEM: `Aucun problème critique ces derniers jours|Un problème critique rencontré ces derniers jours|{nb} problèmes critiques rencontrés ces derniers jours`,
  N_CRITICAL_PENDING_PROBLEM: `.|&nbsp;dont un en attente.|&nbsp;dont {n} en attente.`,
  CRITICAL_PROBLEM_MUST_BE_RESOLVED: `Un problème critique doit être pris en charge dans les 48 heures.`,
  N_ACTIONS: `Aucune action|Une action|{nb} actions`,
  N_PROBLEMS: `Aucun problème|Un problème|{nb} problèmes`,
  N_PROBLEM_MONTHS: `&nbsp;ces 30 derniers jours, {nbPrev} les 30 jours précédents.`,
  N_PROBLEM_INCREASE: `Augmentation de {nb}%.`,
  N_PROBLEM_DECREASE: `Diminution de {nb}%.`,
  N_PROBLEMS_REPORTED: `0 problème remonté | Un problème remonté | {nb} problèmes remontés`,
  N_PROBLEMS_RESOLVED: `0 problème résolu | Un problème résolu | {nb} problèmes résolus`,
  N_RES_REP_PROBLEMS_IMPACT_SUM: `{nProblems} (Somme des impacts: {impact})`,
  NO_PROBLEMS_SINCE: `La dernière remontée de problème était il y a {nDays} jours.`,
  DAILY_MGT_MEANS_DAILY_PROBLEMS: `Dans le management quotidien de la performance, on remonte généralement au moins un problème par jour.`,
  TEACH_PROBLEM_REPORTING: `La remontée de problèmes permet d'améliorer les conditions de travail de l'équipe.`,
  N_UNASSIGNED_ACTIONS: `Il y a {nb} actions non affectées. Une action dans un plan doit avoir un pilote.`,
  USER_MORE_THAN_60PERC_ACTIONS: `L'utilisateur {user} a plus de 60% des actions.`,
  ACTIONS_DISTRIBUTION_STLT: `Répartition des actions : {st}% Court terme / {lt}% Long terme`,
  EVERYONE_SHOULD_PARTICIPATE: `Si c'est possible, répartissez les actions parmi les membres de l'équipe.`,
  DAILY_MGT_ST_LT: `Dans le management quotidien, la plupart des actions doit être prévue à court et moyen termes.`,
  N_LATE_ACTIONS: `Aucune action en retard.|Une action en retard.|Il y a {nb} actions en retard.`,
  IA_HAVE_YOU_TALKED_ABOUT_IT: `En avez-vous parlé récemment ?`,
  REPORT_PROBLEM: `Remonter un problème`,
  PROBLEM_TRUST_INDEX: `Indice de confiance du problème: {index}%`,
  PROBLEM_WELL_DESCRIBED: `Le problème a bien été décrit, bravo !`,
  IA_HOW_PROBLEM_MUST_BE_DESCRIBED: `Les problèmes doivent être bien décrits pour une résolution optimale. Il est notamment primordial d'avoir un visuel et de remplir "Quoi" et "Pourquoi".`,
  CAUSES_TRUST_INDEX: `Indice de confiance des causes: {index}%`,
  CAUSES_ARE_TRUE_CAUSES: `Les causes semblent être des causes réelles !`,
  IA_WHAT_IS_TRUE_CAUSE: `Une cause a un indice de confiance plus élevé si elle est décrite à l'aide d'une image.`,
  ACTIONS_TRUST_INDEX: `Indice de confiance des actions: {index}%`,
  ACTIONS_WELL_LINKED: `Aucun problème, vos actions sont bien liées aux causes du problème.`,
  IA_ACTIONS_SHOULD_BE_LINKED_TO_CAUSES: `Si vous avez déterminé les causes racines du problème, liez les actions à ces causes pour être sûr de leur pertinence.`,
  IMPROVE_PROBLEM_DECRIPTION: `Mieux décrire le problème`,
  PROBLEM_NEEDS_PICTURE: `La meilleure manière de décrire un problème est la photo.<br/>Vous voyez ou avez vu le problème mais la personne qui lira votre description n'est pas dans ce cas. Vos collègues peuvent comprendre différemment le problème tel que vous l'avez vu et ainsi chercher à résoudre un problème qui n'en est pas un.`,
  IDENTIFIER: `Identifiant`,
  IA_TEACH_WHAT: `On pose cette question pour une meilleure description du problème.<br/><br/>Exemples :<br/><em>De quoi s'agit-il ?<br/>Quel est l'état de la situation ?<br/>Quelles en sont les conséquences ?<br/>Quels sont les risques ?</em>`,
  IA_TEACH_WHO: `Cette question permet à chacun de comprendre qui est concerné par le problème.<br/><br/>Exemples :<br/><em>Qui est concerné ?<br/>Qui a le problème ?<br/>Qui est concerné par les conséquences du problème ?<br/>Qui peut être affecté par la résolution ?</em>`,
  IA_TEACH_WHERE: `Cette question concerne la description des lieux. Le problème peut en effet survenir à un endroit pour une raison et à un autre endroit pour une autre.<br/><br/>Exemples :<br/><em>Où le problème est survenu ?<br/>Quels lieux sont impliqués ?<br/>Dans quel atelier, sur quelle machine ?</em>`,
  IA_TEACH_WHEN: `On pose cette question pour bien définir les temps. Ce qui vous aidera à mettre en relation les problèmes qui surviennent dans les mêmes circonstances temporelles.<br/><br/>Exemples :<br/><em>Depuis quand avez vous ce problème ?<br/>Quand apparaît-il ?<br/>Quand le problème a-t-il été découvert ?<br/>Quelle est sa fréquence ?<br/>Quand se produit le risque ?</em>`,
  IA_TEACH_HOW: `Pour une meilleure compréhension de la manière ou de la méthode pour trouver et résoudre ce problème.<br/><br/>Exemples :<br/><em>Comment le problème arrive ?<br/>Dans quelles conditions ou circonstances ?<br/>Comment procède-t-on ?<br/>Y a-t-il des méthodes à utiliser ?<br/>Par quel moyen commencer la résolution, quelles procédures ?</em>`,
  IA_TEACH_HOWMUCH: `Cela permet de quantifier tout ce qui concerne le problème.<br/><br/>Exemples :<br/><em>Quelle quantité d'eau inonde l'atelier ?<br/>Combien de défauts sont sortis avant que l'on détecte le problème ?</em>`,
  IA_TEACH_WHY: `C'est la première étape de la résolution du problème. Vous pouvez commencer par vous demander "Pourquoi ?" à chacune des questions précédentes.<br/>Une fois que la description du problème sera complète et précise, vous pourrez commencer une analyse "5 pourquoi" qui vous permettra de détecter les causes réelles de votre problème.`,
  IA_TEACH_PROBLEM_TYPES: `Donner un type à un problème permet à votre équipe de le ranger dans une catégorie. Par la suite, vous pourrez trier les problèmes plus facilement.`,
  INCREASE_CAUSES_TRUST: `Augmenter la confiance des causes`,
  IA_CAUSE_NEEDS_DESC: `Donner un nom ou une description à une cause est primordial pour la valider. Utiliser des mots crée une compréhension commune de la raison pour laquelle le problème est une conséquence de la cause.`,
  IA_CAUSE_NEEDS_PICTURE: `Comme pour la description du problème, la photo permet à toute personne de comprendre rapidement la signification exacte de la description.<br/>Une image est la preuve que la cause est réelle et doit être résolue.`,
  ADD_DESCRIPTION: `Ajouter une description`,
  ADD_PICTURE: `Ajouter une photo`,
  PICTURE: `Photo`,
  IA_CAUSE_NEEDS_ANY: `La cause est vide. Une cause vide n'a pas d'intérêt pour la résolution du problème. Si vous avez trouvé une cause, vous devriez au moins lui donner un nom ou une description.`,
  MEETING_RATING: `Auto-évaluation`,
  RATE_MEETING: `Donnez une note à la réunion`,
  NO_RATING: `Pas de note`,
  UNACCEPTABLE: `Inacceptable`,
  ACCEPTABLE: `Acceptable`,
  MEETING_ACTIONS: `Actions`,
  MEETING_ACTION_PH: `Action pour les prochaines réunions`,
  REDIRECTING_TO_DASHBOARD: `Redirection vers la page d'accueil...`,
  RATING_UPDATED: `Note mise à jour`,
  LOGOUT: `Déconnexion`,
  LOGGING_OUT: `Déconnexion en cours...`,
  CAMERA_UNAVAILABLE: `Cet appareil n'est pas disponible`,
  NOT_AUTHORIZED_CAMERA: `L'usage de la caméra n'est pas autorisé. Veuillez recharger la page ou modifier les paramètres d'autorisations.`,
  WAKING_NEO_UP: `Attendez... on réveille Neo`,
  ROLES_ASSIGNEMENT: `Affectation des rôles`,
  ROLE_LEADER: `Animateur`,
  ROLE_TIME_KEEPER: `Gardien du temps`,
  ROLE_CARE_TAKER: `Méta`,
  ROLE_DECISION_LEADER: `Pousse décision`,
  ROLE_FOCUS_KEEPER: `Leader éveilleur`,
  ROLE_LEADER_DEF: `Donne le rythme, facilite l'organisation du travail.`,
  ROLE_TIME_KEEPER_DEF: `Aide l’animateur à gérer le temps en fonction des étapes de la réunion.`,
  ROLE_CARE_TAKER_DEF: `Observe les interactions humaines, vérifie que personne n'est à l'écart. <br/>Peut intervenir pour permettre à chacun de s'exprimer.`,
  ROLE_DECISION_LEADER_DEF: `Provoque et note les décisions. <br/>Prend également des notes pendant la réunion sur des points essentiels (décisions, délais, responsabilités, ...).`,
  ROLE_FOCUS_KEEPER_DEF: `Rappelle le but de la réunion et de chacune de ses étapes. <br/>Aide à se concentrer sur la bonne intention.`,
  ROLE_ASSIGNED: `Rôle attribué`,
  ROLES_RANDOM: `Rôles aléatoires`,
  ROLES_REROLL: `Les rôles seront réinitialisés avant d'être réaffectés`,
  DETAILS: `Détails`,
  USERS: `Utilisateurs`,
  TEAMS: `Équipes`,
  COMPANY_DETAILS: `Détails de la société`,
  COMPANY_NAME: `Nom de la société`,
  COMPANY_ID: `ID de la société`,
  CONTACT_EMAIL: `Email de la société`,
  EMAIL: `Email`,
  ACCESS: `Accès`,
  USERS_NB: `Nombre d'utilisateurs`,
  TEAMS_NB: `Nombre d'équipes`,
  CHANGE_CONFIG_PASSWORD: `Modifier le mot de passe administrateur`,
  COMPANY_ID_EXAMPLE: `11000`,
  PWD_BETWEEN_8_25: `La longueur du mot de passe doit être comprise entre 8 et 25 caractères`,
  PWD_DONT_MATCH: `Les mots de passe ne sont pas les mêmes`,
  PWD_EDITED: `Mot de passe mis à jour`,
  PWD_ERROR_CHECK: `Une erreur est survenue, veuillez vérifier les champs`,
  OLD_PASSWORD: `Ancien mot de passe`,
  NEW_PASSWORD: `Nouveau mot de passe`,
  NEW_PASSWORD_CONFIRM: `Confirmation`,
  LOGO_URL: `URL du logo`,
  LOGO_URL_PLACEHOLDER: `Entrez l'URL du logo ici...`,
  USE_WHITE_BG: `Fond blanc`,
  LOGO_UPDATED: `Logo mis à jour`,
  CFG_CHARTS_COLOR: `Couleur des graphes`,
  CFG_COLOR_BLUE: `Bleu`,
  CFG_COLOR_GREEN: `Vert`,
  CFG_CHARTS_FILLING: `Remplissage des graphes`,
  CFG_CHARTS_FILL_GOOD: `Remplir la zone sous les valeurs en accord avec l'objectif`,
  CFG_CHARTS_FILL_BAD: `Remplir la zone sous les valeurs en dehors de l'objectif`,
  CFG_CHARTS_COLOR_OPACITY: `Opacité du remplissage`,
  CFG_CHARTS_COLOR_OPACITY_HINT: `Degré d'opacité de la couleur de remplissage. Plus la valeur est proche de 0, plus le remplissage sera transparent. PLus la valeur est proche de 100, plus le remplissage sera opaque.`,
  SORT_AZ: `de A à Z`,
  SORT_BY_LEVEL: `par niveau hiérarchique`,
  SORT_BY_TEAMS: `par équipe`,
  SORT_BY_TEAMS_AZ: `par équipe (A à Z)`,
  SORT_BY_CREATION_DATE: `date de creation`,
  HIERARCHY_LEVEL: `Niveau hiérarchique`,
  FILTER_BY_TEAM: `Filtrer par équipe de référence`,
  TEAM_UPDATED: `Équipe mise à jour`,
  TEAMS_UPDATED: `Équipes mises à jour`,
  USER_UPDATED: `Utilisateur mis à jour`,
  USERS_UPDATED: `Utilisateurs mis à jour`,
  IMPORT_XLSX: `Importer un fichier excel`,
  XLSX_FILE_ERROR: `Une erreur est survenue avec le fichier. N'hésitez pas à demander conseil à Neo.`,
  XLSX_FILE_SEEMS_EMPTY: `Le fichier excel a l'air vide. N'hésitez pas à demander conseil à Neo.`,
  XLSX_KEEP_TEMP_FORMAT: `Veuillez conserver le format du modèle tel qu'il est. N'hésitez pas à demander conseil à Neo.`,
  DOWNLOAD_XLSX_TEMPLATE: `(Télécharger le modèle)`,
  TEAM: `Équipe`,
  USER: `Utilisateur`,
  NEW_TEAM: `Nouvelle équipe`,
  NEW_USER: `Nouvel utilisateur`,
  NAME: `Nom`,
  YOUR_NAME: `Votre nom`,
  ALREADY_CREATED_TEAMS: `Équipes déjà présentes`,
  ADDING_USERS: `Ajout des utilisateurs...`,
  USERS_ADDED: `Utilisateurs créés`,
  DELETE_SELECTION: `Supprimer`,
  ASSIGN_SELECTION: `Affecter à une équipe`,
  UNSELECT_TEAM: `Déselectionner l'équipe`,
  SELECT_ALL: `Sélectionner tout`,
  UNSELECT_ALL: `Dé-sélectionner tout`,
  CONFIRM_DELETE_USERS: `Voulez-vous vraiment supprimer ces utilisateurs ? <br/>Les données qui leurs sont liées seront également supprimées.`,
  CONFIRM_DELETE_TEAMS: `Voulez-vous vraiment supprimer ces équipes ? <br/>Les données liées seront également supprimées.<br/><br/>Cela inclut les problèmes et leurs résolutions, les actions, les indicateurs et leurs valeurs, et les données relatives aux réunions.`,
  TEAMS_REMOVED: `Équipe(s) supprimée(s)`,
  USERS_REMOVED: `Utilisateur(s) supprimé(s)`,
  CONFIG_ALLOW_SENDING_INFO_ANY_TEAM: `Autoriser les équipes à envoyer une information à n'importe quelle autre équipe`,
  CONFIG_FORCE_ACTION_POSTPMT_REASON: `Demander aux utilisateurs d'indiquer un motif de report d'une action`,
  CONFIG_FORCE_ACTION_POSTPMT_REASON_HINT: `Lors de la modification d'une deadline à une date ultérieure, Shizen demandera aux utilisateurs d'entrer le motif du report pour l'afficher sur la fiche de l'action.`,
  CONFIG_INDICATORS: `Config. indicateurs`,
  CONFIG_DELETE_INDICATORS: `Supprimer les indicateurs`,
  CONFIG_INDICATOR_CHOICES: `De quelle manière souhaitez-vous paramétrer les indicateurs ?<br/><br/><em>En utilisant un modèle, vous pourrez voir les valeurs accumulées de toutes les équipes qui partagent le même modèle.<br/>Vous pouvez également copier les paramètres d'une autre équipe. Mais cette équipe doit utiliser un modèle pour avoir accès à la consolidation des deux équipes.</em><br/><br/>Si vous choisissez de supprimer les indicateurs de cette équipe, vous ne pourrez récupérer aucune des valeurs entrées par l'équipe.<br/>Si ces indicateurs proviennent d'un modèle, les équipes qui utilisent le même modèle ne seront pas affectées.`,
  CONFIG_CURRENT_SCHEME: `L'équipe {team} utilise le modèle "{schemeName}".`,
  CONFIG_CURRENT_NOSCHEME: `L'équipe {team} n'utilise aucun modèle.`,
  CONFIG_CURRENT_SCHEME_PLUR: `Les équipes {teams} utilisent le modèle "{schemeName}".`,
  CONFIG_CURRENT_NOSCHEME_PLUR: `Les équipes {teams} n'utilisent aucun modèle.`,
  CONFIG_ENUM_SEP: `, `,
  CONFIG_ENUM_LAST_SEP: ` et `,
  CONFIG_DISPLAY_TEAMLESS_USERS: `Afficher les utilisateurs sans équipe de référence`,
  CONFIG_DISPLAY_ADMINS_ONLY: `Afficher uniquement les administrateurs`,
  CONFIG_CANT_DELETE_SELF: `Vous ne pouvez pas vous supprimer vous-même.`,
  CONFIG_CANT_REMOVE_LAST_ADMIN: `Vous ne pouvez pas retirer le dernier administrateur de la société.<br>Il doit toujours y avoir au moins un administrateur.`,
  CONFIG_CANT_DELETE_ADMIN_TEAM: `Vous ne pouvez pas supprimer une équipe si elle est utilisée comme équipe de référence pour un administrateur.<br>Vous pouvez retirer le rôle d'administrateur de cet utilisateur ou le déplacer dans une autre équipe.`,
  CONFIG_CHOOSE_TEMPLATE: `Choisir un modèle`,
  COPY_SETTINGS_FROM_OTHER_TEAM: `Copier`,
  CONFIG_WORKING_DAYS: `Config. jours ouvrés`,
  CONFIG_ACTION_PLANS: `Attribuer des plans d'action`,
  CONFIG_PLANS_CHOICES: `Créez de nouveaux plans d'action pour ces équipes ou copiez les paramètres d'une autre équipe.`,
  CREATE_NEW_PLANS: `Nouveaux plans d'action`,
  CONFIG_ASSIGN_CFG_PAGES: `Attribuer des pages paramétrables`,
  CONFIG_ASSIGN_MEETINGS: `Attribuer des réunions`,
  CONFIG_INDIC_SCHEMES: `Modèles d'indicateurs`,
  CONFIG_NO_SCHEMES_FOUND: `Aucun modèle trouvé.`,
  CONFIG_TEAMS_DISPLAY_TEAMS: `Afficher les équipes utilisant ce modèle`,
  CONFIG_TEAMS_USING_TEMPLATE: `Ces équipes utilisent ce modèle`,
  CONFIG_TEAMS_NOT_USING_TEMPLATE: `Ces équipes n'utilisent pas ce modèle`,
  CONFIG_TEAMS_NONE_USING_TEMPLATE: `Aucune équipe n'utilise ce modèle`,
  CONFIG_CREATE_TEMPLATE: `Nouveau modèle`,
  CONFIG_SCHEME_NAME: `Nom du modèle`,
  CONFIG_SCHEME_NAME_PH: `Nom du modèle...`,
  CONFIG_DELETE_SCHEME: `Si vous supprimez ce modèle, les équipes qui l'utilisent ne pourront plus utiliser leurs indicateurs.`,
  CONFIG_SCHEME_DELETED: `Modèle supprimé.`,
  CONFIG_SCHEME_DEFAULT: `Vue par défaut dans la page de management`,
  CONFIG_SCHEME_DEFAULT_HINT: `Cochez cette case pour que ce modèle soit sélectionné par défaut dans la page de management des indicateurs.`,
  CONFIG_CONFIRM_NO_EMAIL: `Si vous utilisez une adresse email invalide pour cette équipe, ses informations de connexion seront envoyées à info@shizen.io.`,
  CONFIG_TEAM_EDITION: `Modification d'une équipe`,
  CONFIG_TEAM_NAME_HINT: `Le nom de l'équipe est le nom utilisé par Shizen pour identifier cette équipe dans les pages du produit. Il est préférable de choisirun nom différent des autres équipes pour éviter de les confondre.`,
  CONFIG_TEAM_EMAIL_HINT: `Cette adresse email est principalement utilisée pour réinitialiser le mot de passe. Elle est aussi utilisée comme adresse email par défaut pour tous les utilisateurs qui n'ont pas rensigné leur propre adresse.`,
  CONFIG_TEAM_HIERARCHY_LEVEL_HINT: `Le niveau hiérarchique est un moyen d'identification visuel pour aider les administrateurs. Il permet également de bloquer l'accès des utilisateurs à certaines données des équipes avec un niveau supérieur.`,
  CONFIG_TEAM_ACCESSES_HINT: `Indiquez ici la liste de tous les utilisateurs qui doivent avoir accès aux données de cette équipe.`,
  CONFIG_TEAM_REMOTE_IDP_ID: `Si vous avez mis en place sur votre fournisseur d'identité, des groupes correspondants aux équipes Shizen, renseignez ici l'identifiant du groupe qui correspond à cette équipe.`,
  CONFIG_REMOTE_IDP_ID: `ID du groupe de l'IdP`,
  CONFIG_COMPANY_INTERNAL_ID: `Identifiant interne dans la société`,
  CONFIG_COMPANY_INTERNAL_ID_HINT: `Identifiant utilisé en interne.`,
  CONFIG_USER_EDITION: `Modification d'un utilisateur`,
  CONFIG_USER_MUST_HAVE_TEAM: `Cet utilisateur doit faire partie d'une équipe`,
  CONFIG_USERNAME_ALREADY_EXISTS: `Ce nom d'utilisateur est déjà utilisé`,
  CONFIG_EMAIL_ALREADY_IN_USE: `Cette adresse email est déjà utilisée`,
  CONFIG_EMAIL_INVALID: `Cette adresse email ne semble pas valide`,
  CONFIG_USERNAME: `Nom d'utilisateur`,
  CONFIG_PREFERRED_TEAM: `Équipe de référence`,
  CONFIG_SEND_USERS_NEW_CREDENTIALS: `Envoyer de nouveaux identifiants`,
  CONFIG_SEND_CREDENTIALS_CONFIRM: `Souhaitez-vous réinitialiser le mot de passe de ces utilisateurs et leur envoyer un nouveau mot de passe par email ?<br>Si une adresse email d'un des utilisateur n'est pas valide, l'adresse email de l'équipe sera utilisée à la place.`,
  CONFIG_RESET_AND_SEND_CREDENTIALS: `Réinitialiser et envoyer`,
  CONFIG_UPDATE_SENDING_USER_EMAIL: `Mise à jour et envoi des emails aux utilisateurs`,
  CONFIG_USER_NAMES_HINT: `Le prénom et le nom de l'utilisateur seront affichés dans les listes d'utilisateurs des équipes et à chaque fois que l'utilisateur sera responsable d'une action ou d'une résolution de problème par exemple.`,
  CONFIG_USERNAME_HINT: `Le nom d'utilisateur permet à celui-ci de se connecter à Shizen. Il peut également se connecter en utilisant l'identifiant de son équipe.`,
  CONFIG_USER_EMAIL_HINT: `L'adresse email permet notamment de réinitialiser le mot de passe de l'utilisateur si celui-ci l'oublie. Il pourra également paramétrer des notifications par email sur la plateforme.`,
  CONFIG_USER_TEAM_HINT: `L'équipe de référence est l'équipe à laquelle l'utilisateur se connectera par défaut sur Shizen. Elle indique également le niveau hiérarchique de l'utilisateur.`,
  CONFIG_USER_TEAMS_HINT: `Les équipes sélectionnées ici sont toutes les équipes desquelles cet utilisateur est membre. Lorsqu'il est connecté, l'utilisateur peut passer d'un compte équipe à un autre à volonté.`,
  CONFIG_THIS_USER_TEAM: `L'équipe de cet utilisateur`,
  CONFIG_USER_ACCESSES_HINT: `L'utilisateur aura une position managériale par rapport aux équipes sélectionnées. Tout utilisateur connecté à "{teamName}" (équipe de référence de cet utilisateur) pourra avoir une vue managériale de ces équipes et pourra leur envoyer des informations.`,
  CONFIG_HIERARCHY_TREE: `Organigramme des équipes`,
  CONFIG_DISPLAY_HIERARCHY_TREE: `Afficher l'organigramme des équipes`,
  CONFIG_HIERARCHY_TREE_HINT: `Cet organigramme est créé à partir des relations hiérarchiques entre les équipes.<br>\
Tant qu'une équipe n'est pas managée par une autre, elle apparaît à la base de l'organigramme.<br>\
Pour essayer de modifier l'organigramme, effectuez des modifications sur les champs "@:message.SUPERVISOR_TEAMS" et "@:message.SUPERVISED_TEAMS" des équipes. Vous pouvez également réorganiser les équipes sur l'organigramme directement à l'aide d'un glisser-déposer.`,
  CONFIG_GW_DISALLOW_COMPLETED_EDITING: `Bloquer l'édition des tournées terrain complétées`,
  SUPERVISOR_TEAMS: `Équipes encadrantes`,
  SUPERVISED_TEAMS: `Équipes supervisées`,
  SUPERVISOR_TEAMS_HINT: `Équipes chargées du management. Dans l'organigramme, "{name}" apparaitra juste en-dessous des équipes que vous sélectionnez dans ce champ. Si cette équipe doit être à la base de l'organigramme, ne sélectionnez aucune équipe.`,
  SUPERVISED_TEAMS_HINT: `Effet inverse du champ précédent. Les équipes sélectionnées ici sont toutes les équipes encadrées par "{name}"`,
  SUPERVISOR_TEAM_ERROR: `L'équipe "{name}" ne peut pas être une équipe encadrante. Elle fait déjà partie des équipes supervisées, ou elle est gérée par une des équipes supervisées.`,
  SUPERVISED_TEAM_ERROR: `L'équipe "{name}" ne peut pas être supervisée. Elle encadre cette équipe, ou encadre une des équipes encadrantes.`,
  SUPERVISOR_TEAM_SELF_ERROR: `Une équipe ne peut pas se superviser elle-même.`,
  CONFIG_USER_ROLES: `Droits de l'utilisateur`,
  CONFIG_USER_ADMIN_ACCESS: `Autoriser l'accès à la config`,
  CONFIG_USER_ADMIN_ACCESS_HINT: `En cochant cette case, l'utilisateur aura un accès à chaque page de la config (Où vous vous trouvez actuellement). <strong>N'autorisez l'accès à la config qu'aux utilisateurs avertis !</strong>`,
  CONFIG_USER_PROBLEMS_ACCESS: `Autoriser la création et la mise à jour des problèmes`,
  CONFIG_USER_PROBLEMS_ACCESS_HINT: `En cochant cette case, l'utilisateur pourra créer et mettre à jour les problèmes`,
  CONFIG_USER_SETTINGS_ACCESS: `Autoriser l'accès aux paramètres d'équipe`,
  CONFIG_USER_SETTINGS_ACCESS_HINT: `En cochant cette case, l'utilisateur pourra modifier les paramètres de son équipe.`,
  CONFIG_USER_SSO_ID: `Identifiant SSO`,
  CONFIG_USER_SSO_ID_HINT: `Ce champ permet de créer une correspondance entre le fournisseur d'identité (IdP) et les utilisateurs Shizen. Pour plus d'informations, consultez @:message.DETAILS > @:(message.SETTINGS_SAML).`,
  CONFIG_SSO_ID_ALREADY_IN_USE: `Cet identifiant SSO est déjà utilisé`,
  CONFIG_ENABLE_ACCOUNT: `Activer les comptes`,
  CONFIG_DISABLE_ACCOUNT: `Désactiver les comptes`,
  CONFIG_DISABLE_ACCOUNT_CONFIRM: `La désactivation de ces comptes fermera les sessions des utilisateurs et les empêchera de se reconnecter à Shizen.<br>Ces utilisateurs n'apparaîtront plus dans les listes d'utilisateurs des comptes des équipes.`,
  CONFIG_ENABLE_ACCOUNT_CONFIRM: `Voulez-vous activer ces comptes pour permettre aux utilisateurs de se connecter à nouveau ?`,
  CONFIG_ACCOUNTS_ENABLED: `Comptes activés`,
  CONFIG_ACCOUNTS_DISABLED: `Comptes désactivés`,
  CONFIG_STARTUP_TEMPLATE: `Utiliser un modèle de démarrage`,
  CONFIG_SAML_PASSWORD_PROTECTED: `Activer la méthode "PasswordProtectedTransport" dans Authn Context`,
  CONFIG_ENABLE_SAML: `Activer l'authentification via SAML (Single Sign On)`,
  CONFIG_FORCE_SAML: `Forcer l'authentification via SAML`,
  CONFIG_FORCE_SSO_HINT: `En cochant cette case, l'authentification classique sur Shizen ne sera plus disponible et redirigera automatiquement l'utilisateur vers la connexion à l'Identity Provider.`,
  CONFIG_SAML_ENTITY_ID: `ID d'entité (Entity ID)`,
  CONFIG_SAML_SSO_URL: `URL de connexion (SSO URL)`,
  CONFIG_SAML_SLO_URL: `URL de déconnexion (SLO URL)`,
  CONFIG_SAML_CERT: `Certificat (base 64)`,
  CONFIG_IMPORT_SAML_XML_META: `Importer les métadonnées au format XML`,
  CONFIG_EXPORT_SAML_XML_META: `Exporter les métadonnées au format XML`,
  CONFIG_IMPORT_SAML_META_HINT: `Votre IdP est susceptible de vous fournir un fichier de métadonnées téléchargeable au format XML afin que vous n'ayez pas besoin de remplir les champs ci-dessous.`,
  CONFIG_SAML_META_FILE_WRONG: `Le fichier fourni ne semble pas être compatible avec le protocole SAML 2.0.`,
  CONFIG_COMPANY_SSO_IDP: `Détails du fournisseur d'identité de votre société (Identity Provider)`,
  CONFIG_SHIZEN_SSO_SP: `Détails de Shizen en tant que Fournisseur de Service (Service Provider)`,
  CONFIG_SAML_SP_ENTITY: `Identifiant de l'entité du fournisseur de service`,
  CONFIG_SAML_ACS_URL: `URL du service consommateur d'assertions (ACS)`,
  CONFIG_SAML_SLS_URL: `URL du service de déconnexion (SLS)`,
  CONFIG_SSO_MATCH_IDP_SHIZEN: `Correspondance entre le fournisseur d'identité (IdP) et les utilisateurs de Shizen`,
  CONFIG_SSO_MATCH_IDP_SHIZEN_HINT: `Pour s'authentifier sur Shizen, les utilisateurs devront d'abord s'authentifier sur le fournisseur d'identité (IdP). L'IdP redirigera ensuite l'utilisateur vers Shizen et fournira certaines informations qui permettront à Shizen d'authentifier cet utilisateur. Pour cela, vous devez choisir ici la propriété qui sera utilisée pour cette authentification.`,
  CONFIG_SAML_EXAMPLE_HINT: `Après l'authentification sur l'IdP, Shizen cherchera un utilisateur dont {shizenProperty} correspond à l'attribut "{idpProperty}" des informations de l'IdP.`,
  CONFIG_SSO_MAPPER_IDP_PROP: `Propriété de l'IdP`,
  CONFIG_SSO_MAPPER_SHIZEN_PROP: `Propriété d'un utilisateur Shizen`,
  CONFIG_SAML_SP_PROPS: {
    email: `l'email'`,
    username: `le nom d'utilisateur`,
    ssoId: `l'identifiant SSO`,
  },
  CONTACT_SHIZEN_ADMIN: `Prenez contact avec l'administrateur de votre compte Shizen pour en savoir plus.`,
  LOGIN_SSO_IDP_FAILED_AUTHENTICATION: `L'authentification de votre fournisseur d'identité a échoué.`,
  LOGIN_SSO_MAPPER_WRONG_IDP_PROP: `Les données reçues depuis votre fournisseur d'identité ne contenaient pas certaines informations requises.`,
  LOGIN_SSO_USER_NOT_FOUND: `L'authentification a fonctionné mais aucun utilisateur de Shizen correspondant à ce compte n'a été trouvé.`,
  LOGIN_SSO_NEW_USER_PROPS_MISSING: `Votre compte n'existe pas dans Shizen et le fournisseur d'identité n'a pas envoyé toutes les données requises.`,
  LOGIN_SSO_NEW_USER_NO_TEAM_MATCH: `Votre compte n'existe pas dans Shizen et les groupes du fournisseur d'identité ne correspondent à aucune équipe de Shizen.`,
  LOGIN_SSO_NEW_USER_CREATION_ERROR: `Une erreur est survenue lors de la création de votre compte`,
  LOGIN_SSO_SUCCESSFUL: `Connexion réussie, vous êtes authentifié en tant que @:(fullNameFormat).`,
  BETA_SSO_LOGIN: `Vous pouvez maintenant vous connecter via SSO (Single Sign On), vous pouvez essayer cette fonctionnalité dès que votre administrateur l'a paramétrée.`,
  CONFIG_TEST_SSO_LOGIN: `Tester la connexion`,
  CONFIG_SETTINGS_OIDC: `Paramètres d'authentification par OpenID Connect (SSO)`,
  CONFIG_ENABLE_OIDC: `Activer l'authentification via OIDC (Single Sign On)`,
  CONFIG_FORCE_OIDC: `Forcer l'authentification via OIDC`,
  CONFIG_OIDC_CLIENT_ID: `Identifiant client`,
  CONFIG_OIDC_SERVER_URL: `URL racine du fournisseur d'identité`,
  CONFIG_OIDC_SECRET: `Clé secrète du fournisseur d'identité`,
  CONFIG_OIDC_ACS_URL: `URL de redirection`,
  CONFIG_OIDC_SLO_URL: `URL de déconnexion (facultative)`,
  CONFIG_CANT_SSO_BOTH_SAML_OIDC: `Vous ne pouvez pas utiliser à la fois SAML et OpenID Connect. Si vous souhaitez autoriser la connexion via OpenID Connect, désactivez la connexion par SAML et réciproquement.`,
  CONFIG_SSO_IDP_GROUPS: `Groupes`,
  CONFIG_SSO_AUTO_CREATE_USERS: `Créer les utilisateurs automatiquement`,
  CONFIG_SSO_AUTO_CREATE_USERS_HINT: `Vous avez également la possibilité d'activer la création automatique des utilisateurs en faisant correspondre les équipes Shizen avec les groupes créés sur votre IdP. Pour cela créez un groupe pour chaque équipe Shizen, puis, pour chacune de ces équipes, remplissez le champ "@:message.CONFIG_REMOTE_IDP_ID" dans les paramètres de l'équipe.<br>Enfin, renseignez ici le nom des propriétés envoyées par votre fournisseur d'identité pour identifier les utilisateurs et leurs groupes à chaque login.`,
  CONFIG_SSO_OIDC_ADD_CLAIM_HINT: `Vous devrez probablement ajouter des revendications (claims) depuis votre fournisseur d'identité, comme les groupes associés à un utilisateur via l'ID token.`,
  CONFIG_OIDC_SCOPES_HINT: `Veuillez indiquer les scopes dont vous avez besoin (séparez chaque valeur par un espace).<br>Par exemple, si vous avez besoin d'une création automatique d'utilisateur, vous avez probablement besoin d'un champ pour accéder au prénom, au nom et au groupe de l'utilisateur.`,
  CONFIG_OIDC_SCOPES: `Scopes`,
  CONFIG_OIDC_SCOPES_PH: `openid profile email`,
  CONFIG_PROBLEMS: `Configuration des problèmes`,
  CONFIG_STARTUP_TEMPLATES: `Modèles de démarrage`,
  CONFIG_SUT_NAME_PH: `Nom du modèle`,
  CONFIG_SUT_N_SCHEMES: `Aucun modèle d'indicateurs|1 modèle d'indicateurs|{n} modèles d'indicateur`,
  CONFIG_SUT_N_PAGES: `Aucune page paramétrable|1 page paramétrable|{n} pages paramétrables`,
  CONFIG_SUT_N_PLANNINGS: `Aucune réunion|1 réunion|{n} réunions`,
  CONFIG_SUT_NEW: `Nouveau modèle de démarrage`,
  CONFIG_SUT_CONFIRM_DELETE: `Souhaitez-vous vraiment supprimer ce modèle ?`,
  CONFIG_SUT_APPLY_SELECTED: `Appliquer les modèles`,
  CONFIG_ACTIONS_HINT: `Vous pouvez définir ici des plans d'action modèles à attribuer à vos équipes.<br>Créez un ou plusieurs plans ici, puis assignez-les à vos équipes depuis la configuration des équipes, ou en utilisant les modèles de démarrage.`,
  CONFIG_ACTION_PLAN_TEMPLATES: `Plans d'action modèles`,
  CONFIG_ACTION_PLAN_LIST_TEAMS: `Équipes utilisant ce plan`,
  LOCATIONS: `Lieux`,
  ADD_A_LOCATION: `Ajouter un lieu`,
  DELETE_SUBZONES: `Souhaitez-vous également supprimer les lieux que contient celui-ci ?`,
  SAVE_BEFORE_ASSIGN: `Cette action n'est pas enregistrée. Enregistrez vos modifications pour affecter l'action.`,
  PB_NOT_FOUND: `Impossible de trouver ce problème. Il a peut-être été supprimé.`,
  PB_GO_BACK: `Retour`,
  NO_CAUSE: `Aucune cause liée`,
  NO_CAUSE_SELECTED: `Aucune cause selectionnée`,
  ACTION_UPDATED: `Action mise à jour`,
  FS_NOT_SUPPORTED: `La fonction plein écran n'existe pas sur ce navigateur.`,
  NOTIFICATIONS: `Notifications`,
  NOTIFICATION: `Notification`,
  NOTIFICATION_TYPE: `Type de notification`,
  NOTIFICATION_EMAIL: `Email`,
  NOTIFICATIONS_SEE: `Paramètres des notifications de`,
  NOTIFICATIONS_SETTINGS_INFO: `Vous pouvez définir ici les paramètres de notifications personnelles.<br>Vous avez la possibilité d'activer/désactiver les notifications qui vous concernent vous ou votre équipe, ainsi que les emails associés à cette notification.`,
  NOTIFICATION_COUNT: `Pas de nouvelle notification|Une notification non lue|{count} notifications non lues`,
  NOTIF_TYPE_UPCOMING_MEETING: `Réunion à venir`,
  NOTIF_TYPE_MEETING_STARTED: `Réunion démarrée`,
  NOTIF_TYPE_ACTION_ASSIGNED: `Nouvelle action assignée à l'équipe`,
  NOTIF_TYPE_ACTION_COMPLETE: `Action terminée par une autre équipe`,
  NOTIF_TYPE_PROBLEM_RECEIVED: `Problème reçu`,
  NOTIF_TYPE_GW_STARTED: `Tournée terrain démarrée`,
  NOTIF_TYPE_INFO_RELEASED: `Nouvelle information`,
  NOTIF_TYPE_PROBLEM_ACCESS_REVOKED: `Accès à un problème révoqué`,
  NOTIF_TYPE_ACTION_RETURNED: `Action renvoyée`,
  NOTIF_TYPE_USER_ACTION_ASSIGNED: `Action affectée`,
  NOTIF_TYPE_USER_ACTION_DEADLINE_OVERDUE: `Deadline d'une action dépassée`,
  NOTIF_TYPE_USER_ACTION_DEADLINE_APPROACHING: `Approche de la deadline d'une action`,
  NOTIF_TYPE_PROBLEM_COMMENT: `Commentaire sur un problème`,
  NOTIF_TYPE_PROBLEM_UPDATE: `Un problème a été mis à jour`,
  NOTIF_TITLE_UPCOMING_MEETING: `@:message.NOTIF_TYPE_UPCOMING_MEETING : {name}`,
  NOTIF_TITLE_ONGOING_MEETING: `@:message.NOTIF_TYPE_MEETING_STARTED : {name}`,
  NOTIF_TITLE_NEW_SUPPORT_ACTION: `Nouvelle action : {name}`,
  NOTIF_TITLE_SUPPORT_ACTION_DONE: `Action terminée : {name}`,
  NOTIF_TITLE_PROBLEM_RECEIVED: `@:message.NOTIF_TYPE_PROBLEM_RECEIVED : {name}`,
  NOTIF_TITLE_GW_STARTED: `@:message.NOTIF_TYPE_GW_STARTED : {name}`,
  NOTIF_TITLE_INFO_RELEASED: `@:message.NOTIF_TYPE_INFO_RELEASED`,
  NOTIF_TITLE_PB_ACCESS_REVOKED: `@:message.NOTIF_TYPE_PROBLEM_ACCESS_REVOKED : {name}`,
  NOTIF_TITLE_ACTION_RETURNED: `@:message.NOTIF_TYPE_ACTION_RETURNED : {name}`,
  NOTIF_TITLE_USER_ACTION_ASSIGNED: `@:message.NOTIF_TYPE_USER_ACTION_ASSIGNED : {name}`,
  NOTIF_TITLE_USER_ACTION_DEADLINE_OVERDUE: `@:message.NOTIF_TYPE_USER_ACTION_DEADLINE_OVERDUE : {name}`,
  NOTIF_TITLE_USER_ACTION_DEADLINE_APPROACHING: `@:message.NOTIF_TYPE_USER_ACTION_DEADLINE_APPROACHING : {name}`,
  NOTIF_TITLE_PROBLEM_COMMENT: `Nouveau commentaire sur : {name}`,
  NOTIF_TITLE_PROBLEM_UPDATE: `@:message.NOTIF_TYPE_PROBLEM_UPDATE : {name}`,
  OTHER_CONNECTED_USERS: `Utilisateurs connectés`,
  PB_HELP_HINT: `Partager`,
  PB_HELP_SHARE: `Vous pouvez partager ce problème avec d'autres équipes`,
  PB_HELP_NO_TEAM_FOUND: `Aucune équipe trouvée.`,
  PB_HELP_ADD_TEAMS: `Ajouter des équipes`,
  PB_HELP_TEAMS_NOTIFIED: `Les équipes ont été informées`,
  PB_HELP_REVOKED: `L'accès a été supprimé`,
  PB_HELP_ACCESS_GRANTED: `Une autre équipe vous a envoyé ce problème`,
  PB_NO_ACCESS: `Il semble que vous n'ayez pas accès à ce problème.`,
  PB_EDITION_ERROR: `Le problème n'a pas pu être édité.<br/>Si le problème persiste, essayez de recharger la page.`,
  PB_AUTO_REFRESH: `Raf. auto`,
  PB_REPORT_SAVE_BEFORE_LEAVE: `Souhaitez-vous enregistrer le problème avant de quitter la page ?`,
  PB_BEEN_REPORTED_TODAY: `Ce problème a été remonté dans les dernières 24 heures`,
  YES_LEAVE_SAVE: `Oui <em class="ml10">(Enregistrer et quitter)</em>`,
  NO_LEAVE_WITHOUT_SAVING: `Non <em class="ml10">(Quitter et supprimer)</em>`,
  CANCEL_NOT_LEAVING: `Annuler <em class="ml10">(Ne pas quitter)</em>`,
  PB_DELETING: `Suppression du problème...`,
  ACTION_SAVE_BEFORE_LEAVE: `Voulez-vous enregistrer l'action avant de quitter la page ?`,
  ACTION_DELETING: `Suppression de l'action...`,
  INFO_SAVE_BEFORE_LEAVE: `Voulez-vous enregistrer l'information avant de quitter la page ?`,
  CAUSE_EDITION_ERROR: `La cause n'a pas pu être éditée. Un autre utilisateur l'a peut-être supprimée.<br/>Si le problème persiste, essayez de recharger la page.`,
  NEW_VERSION_RELOAD: `Une version plus récente est disponible, veuillez recharger la page pour en profiter.`,
  ACCOUNT_LOCKED: `Ce compte a été verrouillé, vous ne pouvez pas vous y connecter.`,
  REFRESH: `Recharger`,
  LIST: `Liste`,
  START_NOW: `Démarrer`,
  CALENDAR: `Calendrier`,
  MEETING: `Réunion`,
  MEETING_FL: `R`,
  GW: `Tournée terrain`,
  GW_FL: `TT`,
  GW_RESTRICTED_ACCESS: `Désolé, vous n'avez pas accès à cette page.`,
  GEMBA_WALKS: `Tournées terrain`,
  GW_MENU: `@:message.GEMBA_WALKS`,
  GW_COMPLETE: `Tournées terrain terminées`,
  GW_CONFIRM_DELETE: `Êtes-vous sûr(e) de vouloir supprimer cette tournée terrain ?<br/>Cette action est irréversible.`,
  GW_ITEM_DELETED: `Élément supprimé`,
  GW_BY_MY_TEAM: `Par cette équipe`,
  GW_FOR_MY_TEAM: `Pour cette équipe`,
  GW_TEMPLATES: `Modèles de tournées terrain`,
  GW_NEW_TEMPLATE: `Nouveau modèle`,
  GW_CREATING_TEMPLATE: `Création d'un nouveau modèle`,
  GW_EDITING_TEMPLATE: `Modification d'un modèle`,
  GW_TEAM_NO_TEMPLATES: `Cette équipe n'a aucun modèle.`,
  GW_TEMPLATE_CONFIRM_DELETE: `Êtes-vous sûr(e) de vouloir supprimer ce modèle ?<br/>Cette action est irréversible.`,
  GW_DUPLICATION_NAME: `Veuillez entrer le nom du nouveau modèle.`,
  GW_TEMPLATE_DUPLICATED: `Modèle dupliqué`,
  GW_EDIT_START: `Modifier avant de démarrer`,
  GW_CHECKLISTS: `Listes de vérification`,
  GW_0_STEPS: `Aucun étape créée`,
  GW_TEAM_NO_CHECKLISTS: `Cette équipe n'a aucune liste de vérification.`,
  GW_CL_DELETE: `Supprimer`,
  GW_CL_DELETED: `Liste supprimée`,
  GW_CL_DELETE_ORPHAN: `Supprimer et supprimer les indicateurs non utilisés`,
  GW_CL_CONFIRM_DELETE: `Êtes-vous sûr(e) de vouloir supprimer cette liste ?<br/>Cette action est irréversible.`,
  GW_CONFIRM_DELETE_ITEM: `Êtes-vous sûr(e) de vouloir supprimer cet élément ?<br/>Cette action est irréversible.`,
  GW_CL_ITEMS: `Éléments`,
  GW_CL_ITEMS_COUNT: `Aucun élément dans cette liste | 1 élément dans cette liste | {count} éléments dans cette liste`,
  GW_CL_ITEM_NB: `Item n°{nb}`,
  GW_CL_ITEM_TYPE: `Type d'item`,
  GW_CL_ITEM_TYPE_OKNOK: `Point de vérification (OK / Non OK)`,
  GW_CL_ITEM_TYPE_GW_INDICATOR: `Saisie d'un indicateur de tournée terrain`,
  GW_CL_ITEM_TYPE_DMP_INDICATOR: `Saisie d'un indicateur d'une équipe`,
  GW_CL_ADD_ITEM: `Ajouter un élément`,
  GW_CL_UNTICK_OPTIONS: `Souhaitez-vous modifier cette liste de vérification ou la retirer de l'étape ?`,
  GW_CL_REMOVE: `Retirer de l'étape`,
  GW_CL_EDIT: `Modifier`,
  GW_SAVED: `Enregistré !`,
  GW_NAME: `Nom`,
  GW_NAME_PLACEHOLDER: `Nom de la tournée de terrain`,
  GW_OBJECTIVE: `Objectif`,
  GW_OBJECTIVE_PLACEHOLDER: `Décrivez l'objectif`,
  GW_SHOULD_SET_AUDITED_USER: `Choisir les personnes à auditer pendant la tournée`,
  GW_PARTICIPANTS: `Participants`,
  GW_ZONES: `Zones`,
  GW_STEP: `Étape`,
  GW_STEPS: `Étapes`,
  GW_STEP_TEAM_HINT: `Ajouter des équipes ici vous permettra de partager la synthèse de cette tournée terrain avec celles-ci.`,
  GW_GOAL: `Objectif`,
  GW_CHECKLIST: `Liste de vérification`,
  GW_CHECKLIST_ITEM: `Point de la liste`,
  GW_NEW: `Nouvelle`,
  GW_OLD: `Ancienne`,
  GW_NEW_COMMENTS: `Nouveaux commentaires`,
  GW_ADD_COMMENT: `Ajouter un commentaire`,
  GW_VALIDATE_STEP: `Valider l'étape`,
  GW_INVALIDATE_STEP: `Invalider l'étape`,
  GW_IS_COMPLETE: `terminée`,
  GW_TEAM_SUMMARY_INTRO: `La tournée terrain "{name}" a eu lieu le {date}. `,
  GW_TEAM_SUMMARY_CHECKS: `Il n'y a eu aucun contrôle.|Sur {nItems} contrôle, <span class="ok-green">{nOk} OK</span> et <span class="nok-red">{nNok} NOK</span>.|Sur {nItems} contrôles, <span class="ok-green">{nOk} OK</span> et <span class="nok-red">{nNok} NOK</span>.`,
  GW_TEAM_MSG_DISPLAY: `Afficher le message principal`,
  GW_TEAM_MSG_DISPLAY_CUSTOM: `Afficher un message personnalisé`,
  GW_TEAM_MSG_HINT: `Vous pouvez sélectionner ici les équipes auxquelles vous souhaitez envoyer un court résumé de la tournée. Vous pouvez également entrer un message personnalisé par équipe.<br/>Les messages envoyés à partir de cette fenêtre apparaîtront sur la page des informations des équipes.<br/>Si vous ne souhaitez pas envoyer de message aux équipes, pensez à décocher les cases concernées (Les cases peuvent être cochées ou décochées par défaut depuis les paramètres).`,
  GW_TEAM_MSG_NONE: `Aucune équipe auditée dans cette tournée. Vous pouvez ajouter des équipes à auditer depuis la page du modèle de cette tournée.`,
  GW_TEAM_SEND: `Envoyer à {teamName}`,
  GW_END_GW: `Terminer la tournée`,
  GW_TEAM_LINKED_TO_STEP: `Équipe liée à l'étape`,
  GW_NO_LINKED_TEAM: `Aucune équipe liée`,
  GW_NO_TEAM_IN_TEMPLATE: `Aucun équipe n'a été définie dans le modèle de la tournée terrain.<br/>Pensez à définir une équipe si vous souhaitez récupérer ses problèmes et ses actions.`,
  GW_NO_NAME: `Aucun nom attribué`,
  GW_FETCH_PROBLEMS: `Charger les problèmes`,
  GW_FETCH_ACTIONS: `Charger les actions en cours`,
  GW_STEP_PREVIOUS: `Étape de la tournée précédente`,
  GW_SUMMARY: `Récapitulatif`,
  GW_N_COMMENTS: `0 com.|1 com.|{n} coms.`,
  GW_N_PROBLEMS: `0 problème|1 problème|{n} problèmes`,
  GW_N_ACTIONS: `0 action|1 action|{n} actions`,
  GW_CONFIRM_DEL_PB: `Souhaitez-vous vraiment supprimer ce problème ?<br/>Toutes les données associées (causes, actions, images) seront également supprimées.`,
  GW_CONFIRM_DEL_ACTION: `Souhaitez-vous vraiment supprimer cette action ?`,
  GW_SHOW_ALL_PROBLEMS: `Tous les problèmes`,
  GW_SHOW_PROBLEMS_FOR: `Problèmes de "{step}"`,
  GW_SHOW_ALL_ACTIONS: `Toutes les actions`,
  GW_SHOW_ACTIONS_STEP: `Actions de "{step}"`,
  GW_SHOW_ACTIONS_OF_PB: `Actions d'un problème`,
  GW_SHOW_ACTIONS_PB: `Actions de "{pb}"`,
  GW_DISPLAY_COMMENTS: `Afficher les commentaires`,
  GW_DISPLAY_CHECKLISTS: `Afficher les listes`,
  GW_SET_ACTION_TEAM: `Définissez une équipe pour cette action`,
  GW_NO_PB_SELECTED: `Aucun problème sélectionné`,
  GW_SYNTHESIS: `Synthèse`,
  GW_DETAILED: `En détails`,
  GW_STEPS_PROBLEMS: `| Problèmes de l'étape | Problèmes des étapes`,
  GW_STEPS_CL_PROBLEMS: `| Problèmes des checklists de l'étape | Problèmes des checklists des étapes`,
  GW_CONFIRM_DELETE_PLANNING: `Êtes-vous sûr(e) de vouloir supprimer cette planification ?<br/>La tournée terrain n'apparaîtra plus dans l'agenda.<br/>Cette action est irréversible.`,
  GW_NO_STEPS: `Aucune étape n'a été créée. Ajoutez en au moins une afin de lancer une tournée terrain`,
  GW_NO_ACCESS_PLANNING: `Vous ne pouvez pas modifier la planification d'une autre équipe.`,
  GW_PLANNING_DELETED: `Planification supprimée`,
  GW_NEW_CL: `Nouvelle liste`,
  GW_WAS_EDITED_REFRESH: `La tournée a été modifiée. Cliquez ici pour rafraîchir.`,
  GW_STATS: `Statistiques des tournées`,
  GW_NOT_APPLICABLE: `Non applicable`,
  GW_OK_ITEMS: `Points valides`,
  GW_NOK_ITEMS: `Points invalides`,
  GW_PICK_LOCATION: `Choisir un lieu`,
  GW_PICK_TEAM: `Choisir une équipe`,
  GW_PICK_USER: `Choisir un utilisateur`,
  GW_AUDITED_TEAMS: `Équipes auditées`,
  GW_AUDITED_USERS: `Utilisateurs audités`,
  GW_AUDITED_USER: `Utilisateur audité`,
  GW_PICK_CHECKLIST: `Choisir une liste`,
  GW_TEMPLATES_SHORT: `Modèles`,
  GW_PICK_TEMPLATE: `Choisir un modèle`,
  GW_CLICK_TO_SEE_PB: `Cliquez pour voir les problèmes`,
  GW_CLICK_TO_HIDE_PB: `Cliquez pour cacher les problèmes`,
  GW_OVER: `La tournée terrain est terminée`,
  GW_GOTO_SUMMARY: `Aller à la synthèse`,
  GW_STAY: `Rester sur cette page`,
  GW_CANCELLED: `Cette tournée terrain vient d'être annulée`,
  GW_PREV_PAGE: `Page précédente`,
  GW_PAGES: `Pages des tournées terrain`,
  GW_LAST_COMPLETE: `Dernière tournée terrain terminée`,
  GW_TEAM_N_PROBLEMS: `Aucun problème dans cette équipe|Cette équipe a 1 problème|Cette équipe a {n} problèmes`,
  GW_TEAM_1_LATE_PROBLEMS: `, et il est en retard.`,
  GW_TEAM_N_LATE_PROBLEMS: `, aucun n'est en retard.|, dont un en retard.|, dont {n} en retard.`,
  GW_TEAM_N_ACTIONS: `Aucune action en cours|Une action en cours dans cette équipe|{n} actions en cours pour cette équipe`,
  GW_TEAM_1_LATE_ACTIONS: `, et elle est en retard.`,
  GW_TEAM_N_LATE_ACTIONS: `, aucune n'est en retard.|, dont une en retard.|, dont {n} en retard.`,
  GW_RATE_REVIEW: `Donner un avis`,
  GW_PREVIEW_TOUR: `Voir la tournée`,
  GW_SEND_RATING: `Soumettre l'avis`,
  GW_PROMPT_RATE_REVIEW: `Souhaitez-vous attribuer une note et un commentaire à cette tournée terrain ?`,
  GW_MOOD: `Ressenti`,
  GW_RELEVANCE: `Pertinence`,
  GW_RATE_MOOD: `Évaluez votre ressenti de cette tournée`,
  GW_RATE_RELEVANCE: `Évaluez la pertinence de la tournée`,
  GW_RATE_MOOD_QUESTIONS: `Comment s'est passée la tournée ?<br/>Les échanges reflétaient-ils un respect mutuel ?<br/>Quel est le ressenti global de chacun ?`,
  GW_RATE_RELEVANCE_QUESTIONS: `Avez-vous l'impression que la tournée était utile ?<br/>Lorsqu'on vous a fait des remarques, étaient-elles claires et constructives ?<br/>Avez-vous reçu de l'aide là où vous en aviez besoin ?`,
  GW_RATING_NEEDED_COMMENT: `Veuillez laisser un commentaire pour que les participants de la tournée sachent ce qu'ils peuvent améliorer`,
  GW_RATING_OPTIONAL_COMMENT: `Vous pouvez laisser un commentaire si vous désirez faire remonter une information aux participants de la tournée`,
  GW_REVIEW_SAVED: `Votre avis a été enregistré`,
  GW_REVIEWS: `Avis et commentaires`,
  GW_CANCEL_CONFIRM: `Souhaitez-vous vraiment supprimer cette tournée terrain ?<br/>Toutes les données associées seront supprimées.<br/><br/>Cette action est irréversible.`,
  GW_NOT_FOUND: `Nous n'avons pas retrouvé cette tournée terrain. Elle a peut-être été supprimée ou vous n'y avez pas accès.`,
  GW_N_ONGOING: `| Vous avez une tournée terrain en cours. | Vous avez {nb} tournées terrain en cours.`,
  GW_CANT_SELECT_NO_TEAMS: `Vous devez choisir une équipe`,
  GW_DEFAULT_TICK_TEAMS_TITLE: `Envoyer le résumé de la tournée aux équipes concernées`,
  GW_DEFAULT_TICK_TEAMS_HINT: `Cochez cette case pour sélectionner automatiquement toutes les équipes concernées par la tournée terrain, dans la fenêtre d'informations lorsque la tournée est terminée.`,
  GW_DEFAULT_TICK_TEAMS: `Sélectionner toutes les équipes par défaut`,
  GW_DEFAULT_HIDE_PREVIOUS: `Masquer la section de la tournée précédente par défaut`,
  GW_DEFAULT_HIDE_PREVIOUS_HINT: `En cochant cette option, au démarrage d'une tournée terrain, la section de droite contenant les informations de la tournée précédente sera masquée par défaut. Vous aurez toujours la possibilité de l'ouvrir après avoir lancé la tournée.`,
  GW_INDICATORS: `Indicateurs de tournée terrain`,
  GW_HIDDEN_DAYS_ARE: `Jours cachés`,
  GW_HIDE_WD: `Cacher les jours non ouvrés`,
  GW_NON_WD: `Jours non ouvrés`,
  GW_CUMULATED_NON_WD: `@:message.GW_CUMULATED_NON_WD_BEGINNING il n'y a aucun jour non ouvré par semaine | @:message.GW_CUMULATED_NON_WD_BEGINNING il y a un jour non ouvré par semaine | @:message.GW_CUMULATED_NON_WD_BEGINNING il y a {nb} jours non ouvrés par semaine`,
  GW_CUMULATED_NON_WD_BEGINNING: `En cumulant les jours ouvrés des équipes sélectionnées, `,
  GW_N_NA_ITEMS: `Aucun éléments N/A|1 élément N/A|{nb} éléments N/A`,
  GW_N_OK_ITEMS: `Aucun éléments OK|1 élément OK|{nb} éléments OK`,
  GW_N_NOK_ITEMS: `Aucun élément NOK|1 élément NOK|{nb} éléments NOK`,
  GW_NOK_ITEMS_PARETO: `Éléments NOK (Non OK) les plus récurrents`,
  GW_NOK_ITEMS_PARETO_ZONES: `Zones avec le plus d'éléments NOK`,
  GW_NOK_ITEMS_PARETO_TEAMS: `Équipes auditées avec le plus d'éléments NOK`,
  GW_NOK_CHART_MESSAGE: `<b>Attention</b>: Les tournées terrain lancées avant le 20 octobre 2019 ne sont pas prises en compte sur ce graphe.`,
  GW_ITEMS_OK_CHART: `Évolution des pourcentages de 'OK', 'NOK' et 'Non applicable' dans le temps`,
  GW_PLANNING_CHART: `Respect des plannings de tournée terrain`,
  GW_OVERALL_STATS: `Répartition générale`,
  GW_PLANNED_BUT_NOT_CARRIEDOUT: `Planifiées mais pas exécutées`,
  GW_NO_PROBLEMS_STEP: `Aucun problème lié à l'étape`,
  GW_STEP_COMMENTS: `Commentaires de l'étape`,
  GW_STEP_NO_CL: `Aucune checklist à cette étape`,
  GW_NO_ACCESS: `Votre équipe n'a pas accès à cette tournée terrain.`,
  GW_LEAVE_START: `Vous allez quitter la page. Aucune modification effectuée sur cette tournée terrain ne sera enregistrée.`,
  GW_CONFIRM_REMOVE_STEP: `Voulez-vous vraiment supprimer cette étape ?`,
  GW_NO_STEP_COMMENT: `Aucun commentaire pour cette étape.`,
  COPY_OF: `Copie de {sth}`,
  PICK_THEME: `Veuillez choisir un thème.`,
  ZONE_INCLUSIVE: `Inclure les sous-zones`,
  TYPE_INCLUSIVE: `Inclure les sous-types`,
  JIRA_TRIGGER: `Signaler un bug`,
  JIRA_TRIGGER_BUGS: `Accéder aux bugs`,
  JIRA_WHAT_TYPE: `Souhaitez-vous nous envoyer :`,
  JIRA_TYPE_BUG: `Un bug`,
  JIRA_TYPE_IMPROVE: `Une amélioration`,
  JIRA_DESCRIPTION: `Description`,
  JIRA_DESCRITION_HINT: `N'hésitez pas à fournir autant de détails que possible pour décrire la situation que vous rencontrez.<br/>Par exemple, vous pouvez nous décrire les étapes qui vous ont permis de trouver le bug.`,
  JIRA_ISSUE_REPORTED: `Le problème a été signalé. Merci de nous avoir contactés, nous vous recontacterons rapidement.`,
  JIRA_ISSUE_CREATION_ERROR_DESCRIPTION: `Nous vous prions de rentrer une description afin d'envoyer votre demande.`,
  JIRA_HOW_ADD_ATTACHMENT: `De quelle manière souhaitez-vous ajouter un fichier ?`,
  JIRA_UPLOAD_ATTACHMENT_SUCCESS: `Le fichier a bien été ajouté.`,
  JIRA_DELETE_ATTACHMENT_SUCCESS: `Le fichier a bien été supprimé.`,
  H_TEXT_ALIGN: `Alignement horizontal`,
  V_TEXT_ALIGN: `Alignement vertical`,
  ALIGN_TEXT_WHERE: `Aligner le texte`,
  CENTER_TEXT_WHERE: `Centrer le texte`,
  ALIGN_TEXT_TOP: `@:message.ALIGN_TEXT_WHERE en haut`,
  ALIGN_TEXT_BOT: `@:message.ALIGN_TEXT_WHERE en bas`,
  ALIGN_TEXT_MID: `@:message.CENTER_TEXT_WHERE verticalement`,
  ALIGN_TEXT_LEFT: `@:message.ALIGN_TEXT_WHERE à gauche`,
  ALIGN_TEXT_RIGHT: `@:message.ALIGN_TEXT_WHERE à droite`,
  ALIGN_TEXT_CENTER: `@:message.CENTER_TEXT_WHERE horizontalement`,
  CFG_PAGES: `Pages paramétrables`,
  PAGE: `Page`,
  WIDGET: `Widget`,
  WIDGETS: `Widgets`,
  CFG_PAGE_CONFIG: `Paramètres de la page`,
  CFG_PAGE_WIDGET_CONFIG: `Paramètre du widget`,
  CFG_PAGE_SPEC_CONFIG: `Paramètres spécifiques`,
  CUST_PAGES_N_WIDGET: `(Aucun widget)|(1 widget)|({n} widgets)`,
  CUST_PAGES_NEW: `Nouvelle page paramétrable`,
  CFG_PAGES_CREATED: `Page ajoutée`,
  CFG_PAGES_DELETED: `Page supprimée`,
  CFG_PAGES_CONFIRM_DELETE: `Supprimer cette page ?`,
  CFG_PAGES_HINT_ADD_WIDGET: `Ajouter des widgets en faisant glisser des éléments depuis le panneau de droite.`,
  CFG_PAGE_NAME: `Nom de la page`,
  CFG_PAGE_ADD_MENU: `Ajouter la page au menu`,
  CFG_PAGE_PREVIEW: `Aperçu de la page`,
  CFG_PAGE_ALLOW_TEAM_CREATING_TEMPLATE: `Autoriser les équipes à créer des modèles à partir de leurs propres pages`,
  CFG_PAGE_MAKE_TEMPLATE: `Créer un modèle à partir de cette page`,
  CFG_PAGE_ALREADY_HAS_TEMPLATE: `Un modèle existe déjà pour cette page`,
  CFG_PAGE_COLOR: `Couleur de fond`,
  CFG_PAGE_NO_WIDGET_SELECTED: `Aucun widget sélectionné. Cliquez sur un widget pour le modifier.`,
  CFG_PAGE_DUPLICATE_WIDGET: `Dupliquer le widget`,
  CFG_PAGE_LIBRARY_INDIC_HINT: `Le champ ci-dessus vous permet de choisir un indicateur de la bibliothèque. Lors de l'attribution de cette page à une équipe, Shizen cherchera l'indicateur choisi parmi ses indicateurs et l'affichera dans ce widget.`,
  FILTER_CFG_PAGES: `Filtrer les pages paramétrables`,
  CFG_PAGE_LOCK_IMPORT: `Verrouiller la page`,
  CFG_PAGE_LOCK_IMPORT_HINT: `En verrouillant cette page, les équipes ne pourront pas l'importer depuis leurs paramètres. Cependant, la page peut être assignée à n'importe quelle équipe à partir de la config.`,
  CFG_PAGE_SYNCED: `Synchroniser la page`,
  CFG_PAGE_SYNCED_HINT: `Lorsque la synchronisation est activée, les modifications faites sur cette page mettront également à jour les pages des équipes qui l'utilisent. De plus, les équipes ne pourront pas modifier les widgets existants, mais pourront en ajouter de nouveaux.`,
  CFG_PAGE_CANT_EDIT_TEMPLATE_WIDGET: `La synchronisation est activée sur cette page et ce widget fait partie du modèle. Vous ne pouvez pas le modifier.`,
  CFG_PAGES_IMPORT_TEMPLATE: `Importer un modèle`,
  CFG_PAGE_SNAPPING: `Ancrage des widgets`,
  CFG_PAGE_SNAPPING_SPACE: `tous les`,
  CFG_PAGE_SNAP_EACH_OTHER: `les uns aux autres`,
  CFG_PAGE_SNAP_GRID: `à une grille`,
  CFG_W_DESIGN_OPTIONS: `Options d'apparence`,
  CFG_W_INNER_MARGIN: `Marge intérieure`,
  CFG_W_INNER_MARGIN_HINT: `La marge maximale est de 10`,
  CFG_W_BORDER: `Bordure`,
  CFG_W_ROUNED_CORNER: `Coins arrondis`,
  WIDGET_DELETE: `Supprimer le widget`,
  WIDGET_CONFIRM_DELETE: `Supprimer le widget ?`,
  WIDGET_NAME_TEXT: `Paragraphe de texte`,
  WIDGET_NAME_TEXT_PER_DATE: `Saisie de texte par date`,
  WIDGET_NAME_PENDING: `Liste des actions en attente`,
  WIDGET_NAME_BUTTON: `Lien vers un autre site`,
  WIDGET_HELP: `Déplacez cet élément avec votre souris et changez sa taille en utilisant les coins bleus.`,
  WIDGET_TEXT_CONTENT: `Contenu`,
  WIDGET_TEXT_SIZE: `Taille du texte`,
  WIDGET_TEXT_FONT_HINT: `La taille du texte sera {mult} fois la taille de la police de Shizen.`,
  WIDGET_TEXT_ALLOW_EDIT: `Contenu modifiable`,
  WIDGET_TEXT_ALLOW_SCROLL: `Contenu défilable`,
  WIDGET_TEXT_ADAPT_FONT_SIZE: `Adapter la police à la taille du widget`,
  WIDGET_PICTS_ONLY_ONE: `Une seule image`,
  WIDGET_PICTS_EDITABLE: `Images modifiables en dehors du mode édition`,
  WIDGET_PICTS_EDITABLE_HINT: `En cochant cette option, l'interaction avec les fichiers PDF ne sera plus possible.`,
  IMAGES: `Images`,
  IMAGES_AND_DOCS: `Images et documents`,
  WIDGET_SHOW_ICON: `Montrer l'icône du site`,
  WIDGET_PLANS_OF_CURRENT_TEAM: `Vos plans`,
  WIDGET_NO_PLANS_SELECTED: `Aucun plan d'action sélectionné`,
  WIDGET_INDIC_CUULATED: `Indicateur cumulé`,
  WIDGET_INDIC_DISPLAY_RANGE: `Afficher l'éditeur de période`,
  WIDGET_INDIC_GAP_DAYS: `Décalage (en jours)`,
  WIDGET_INDIC_HINT_ONEDAY: `Aujourd'hui, cet indicateur afficherait la valeur du {day}`,
  WIDGET_INDIC_HINT_RANGE: `Aujourd'hui, cet indicateur afficherait les valeurs du {start} au {end}`,
  WIDGET_INDIC_NO_SELECTED: `Aucun indicateur sélectionné`,
  WIDGET_INDICS_OF_CURRENT_TEAM: `Vos indicateurs`,
  WIDGET_DETAILED_DETAILS: `Afficher les détails`,
  WIDGET_DETAILED_ANALYSIS: `Afficher l'analyse`,
  WIDGET_DETAILED_PB_ACTIONS: `Afficher les problèmes et les actions`,
  WIDGET_PB_LIST: `Liste de problèmes`,
  WIDGET_PB_SORT: `Options de tri`,
  WIDGET_NAME_VIEWER: `Visionneur (PDF, vidéo)`,
  WIDGET_VIEWER_WHAT: `Afficher`,
  WIDGET_VIEWER_PDF: `Fichier PDF`,
  WIDGET_VIEWER_VIDEO: `Vidéo`,
  WIDGET_VIEWER_ADDRESS: `Adresse URL`,
  WIDGET_VIEWER_HTTPS: `https://`,
  WIDGET_VIEWER_LOADING: `Chargement du contenu externe ...`,
  WIDGET_VIEWER_NOT_VALID: `Le lien URL n'a pas l'air de fonctionner. Le widget permet d'afficher des vidéos de YouTube, dailymotion et Vimeo.`,
  WIDGET_VIEWER_MISSING_ADDRESS: `Veuillez ajouter l'adresse URL.`,
  WIDGET_VIEWER_UPLOAD_PDF: `Charger depuis l'appareil`,
  WIDGET_NAME_WHEEL: `Vue mensuelle des indicateurs`,
  WIDGET_WHEEL_NO_THEME: `Pas de thème sélectionné`,
  WIDGET_WHEEL_HIDE_CONTROLS: `Cacher les contrôles de navigation`,
  WIDGET_WHEEL_HIDE_INFO: `Cacher les informations supplémentaires`,
  WIDGET_NAME_PAGES_SLIDESHOW: `Diaporama de pages`,
  SLIDESHOW_CONTROLS: `Afficher les flèches de navigation`,
  SLIDESHOW_AUTO_SCROLL: `Défilement automatique`,
  SLIDESHOW_LIMIT_REACHED: `Il ne peut y avoir que 2 diaporamas par page au maximum.`,
  SLIDESHOW_NESTED_EMBED: `Le contenu ne peut être affiché.<br/>Un widget diaporama ne peut pas contenir un autre widget diaporama.`,
  SLIDESHOW_ALLOW_INTERACTION: `Activer l'intéraction avec le contenu du widget`,
  WIDGET_NAME_STICKERS: `Notes amovibles`,
  WIDGET_TEXT_PER_DATE_PERIOD_HINT: `Choisissez ici l'unité de temps que vous souhaitez utiliser pour vous déplacer d'une période à une autre.`,
  WIDGET_PROBLEMS_SHOW_DELETE_BTN: `Afficher le bouton de suppression sur les problèmes`,
  IDC_CHART: `Configuration des graphes`,
  IDC_AVAILABLE: `Configurations disponibles`,
  IDC_NEW: `Nouvelle configuration`,
  IDC_EDITION: `Édition de la configuration`,
  IDC_PRESETS: `Préréglages`,
  IDC_NAME: `Nom de la configuration`,
  IDC_POINT_PERIOD: `Période d'un point`,
  IDC_SIMPLIFIED_PRESETS_HINT: `Le mode simplifié vous permet de choisir parmi les préréglages suivants. En cliquant sur un préréglage, la configuration sera automatiquement mise à jour.<br/>Cependant, si vous avez besoin d'options plus spécifiques, vous pouvez passer en mode avancé.`,
  IDC_POINT_PERIOD_HINT: `Sur le nouveau graphique, un point cumulera les valeurs de {period} du graphique normal.`,
  IDC_CHART_PERIOD: `Étendue visible du graphique`,
  IDC_CHART_PERIOD_HINT: `Il affichera une étendue totale de {period}.`,
  IDC_INCR_CUMUL_VALUES: `Valeurs cumulées croissantes`,
  IDC_INCR_CUMUL_VALUES_HINT: `Les valeurs augmenteront à partir du début de chaque intervalle de cumul jusqu'à la fin de celui-ci.`,
  IDC_INCREASE_INTERVAL: `Intervalle de cumul des valeurs`,
  IDC_INCREASE_PERIOD_HINT: `Les valeurs augmenteront au sein d'intervalles de {period}.`,
  IDC_INCR_CUMUL_OBJ: `Objectifs cumulés croissants`,
  IDC_INCR_CUMUL_OBJ_HINT: `Les objectifs augmenteront de la même manière que les valeurs.`,
  IDC_USE_FIXED_END_DATE: `Définir une date de fin fixe pour le graphe`,
  IDC_END_DATE: `Date de fin du graphe`,
  IDC_CURRENT_DATE: `Date du jour`,
  IDC_CURRENT_DATE_GAP: `Date du jour avec un décalage`,
  IDC_FIXED_END_DATE: `Date fixe de fin du graphe`,
  IDC_END_DATE_HINT: `En utilisant une date fixe pour la fin du graphe, vous n'aurez pas la possibilité de déplacer la période manuellement. Les valeurs affichées sur votre graphe seront toujours les mêmes.<br>Vous pouvez également choisir la date du jour avec un décalage afin, par exemple, d'afficher la semaine ou le mois précédent par défaut.`,
  IDC_PRESET_1: `Valeurs croissantes par période de 1 mois. Objectif statique.`,
  IDC_PRESET_2: `Valeurs croissantes par période de 1 mois. Objectif croissant.`,
  IDC_PRESET_3: `Indicateur à la semaine (valeurs cumulées sur une semaine).`,
  IDC_PRESET_4: `Valeurs de la semaine passée.`,
  IDC_PRESET_5: `Valeurs cumulées de la semaine passée.`,
  IDC_SAVING: `Enregistrement ...`,
  IDC_SAVED: `Configuration enregistrée`,
  IDC_CUSTOM: `Configurations personnalisées`,
  IDC_CONFIG_IS_DEFAULT: `Cette configuration est définie par défault, vous ne pouvez pas la modifier.`,
  IDC_DETAILED_INDIC_HINT: `NOTE: Sur la page d'un indicateur détaillé, l'étendue du graphe sera de 365 jours.`,
  WIDGET_IMAGE_SIZE: `Taille de l'image`,
  TITLE: `Titre`,
  WIDGET_BUTTON_LINK: `Lien`,
  RECURRENCE: `Récurrence`,
  NO_PB_FOUND: `Aucun problème trouvé`,
  COMPARING_NB_OF_TOTAL: `Comparaison de {nb} sur {total}`,
  SIMILAR_PBS: `Problèmes similaires`,
  SIMILARITIES_FIELDS: `Ressemblances sur {fieldsWord} {fieldsList}`,
  FIELDS_SUFFIX: `le champ | les champs`,
  NO_SIMILARITY: `Aucune ressemblance`,
  RECURRENCE_DUPLICATE: `Identique`,
  RECURRENCE_DUPLICATE_SHORT: `Ide.`,
  RECURRENCE_DUPLICATE_HINT: `Cochez cette case si vous pensez que les problèmes sont identiques ou presque et que la compréhension du premier problème devrait aider à résoudre le second.`,
  RELATED: `En lien`,
  RELATED_SHORT: `Lié`,
  RELATED_HINT: `Cochez cette case si les problèmes sont liés et qu'il peut y avoir des causes ou des actions communes.`,
  RECURRENCE_N_DUPLICATE: `Aucun problème identique | 1 problème identique | {nb} problèmes identiques`,
  RECURRENCE_N_RELATED: `Aucun problème en lien | 1 problème en lien  | {nb} problèmes en lien`,
  DISPLAY_QUICK_FILTERS: `Afficher les filtres rapides`,
  QFILTER_MY_TEAM: `Mon équipe`,
  QFILTER_OTHER_TEAMS: `Autres équipes`,
  QFILTER_RESOLVED: `Résolus`,
  QFILTER_NOT_RESOLVED: `Non résolus`,
  QFILTER_ARCHIVED: `Archivés`,
  QFILTER_NOT_ARCHIVED: `Non archivés`,
  SIMILARITY_PERC_NEO: `Neo a trouvé une similitude de {perc}% entre ces deux problèmes`,
  PB_DUPLICATE_MERGE_CONFIRM: `Ces deux problèmes sont identiques à des problèmes différents. Voulez-vous fusionner les relations de récurrence pour que tous ces problèmes soient considérés comme identiques ?`,
  PB_DUPLICATE_MERGE: `Fusionner`,
  SCREEN_SAVER: `Écran de veille`,
  ENABLE_SCREEN_SAVER: `Activer l'écran de veille`,
  SCREEN_SAVER_TIMEOUT: `Lancer l'écran de veille après`,
  KEEP_SCREEN_SAVER_PAGE: `Rester sur la dernière page de l'écran de veille`,
  PAGES: `Pages`,
  ADD_PAGE: `Ajouter une page`,
  SOCKET_CONNECTING: `La synchronisation est en cours de mise en place.`,
  SOCKET_READY: `La synchronisation est en place.`,
  SOCKET_CLOSED: `La synchronisation est fermée. Cliquez pour la relancer.<br>Si un onglet s'ouvre lors du clic, le navigateur peut vous demander d'autoriser la connexion à un certificat SSL.<br>Si c'est le cas, la connexion ne pourra se faire que si vous acceptez la connexion.`,
  INDICATORS_LIBRARY: `Bibliothèque d'indicateurs`,
  CONFIG_COLLAPSE_ALL: `Tout fermer`,
  CONFIG_EXPAND_ALL: `Tout ouvrir`,
  NAME_PH: `Nom...`,
  THEME_NAME_PH: `Nom du thème...`,
  LIBRARY_INDIC_UNCATEGORIZED: `Sans catégorie`,
  LIBRARY_INDIC_MERGE: `Fusionner avec...`,
  LIBRARY_INDIC_MOVE: `Déplacer`,
  LIBRARY_INDIC_HINT: `Cette page affiche tous les indicateurs de l'entreprise.<br/>Vous pouvez ajouter ces indicateurs aux tableaux de bord de vos équipes en vous rendant dans leurs paramètres ou en leur appliquant un modèle. Vous pouvez voir, pour chaque indicateur ci-dessous, le nombre d'équipes auxquelles il a été affecté.<br/><br/>Le fait d'avoir une seule référence pour un indicateur présent chez plusieurs équipes, permet aux managers de voir les valeurs accumulées sur un seul graphique.<br/>Vous pouvez également créer un modèle afin d'avoir un préréglage dans la page des indicateurs cumulés ou d'affecter un ensemble d'indicateurs à plusieurs équipes rapidement.`,
  LIBRARY_INDIC_MERGE_HINT: `Fusionner deux indicateurs vous permet d'afficher une vue cumulée des valeurs de plusieurs équipes. Si vous avez créé deux indicateurs pour suivre les accidents par exemple, vous pouvez les fusionner pour que la page de gestion des indicateurs affiche la somme des accidents.<br/>La fusion de deux indicateurs de la bibliothèque n'affectera pas les indicateurs des équipes.`,
  LIBRARY_INDIC_MERGE_SAME: `Vous ne pouvez pas fusionner un indicateur avec lui-même.`,
  LIBRARY_INDIC_DELETE_THEME_CONFIRM: `Souhaitez-vous vraiment supprimer cette catégorie ?<br/>Tous les indicateurs concernés seront ajoutés aux indicateurs sans catégorie.<br/>Les équipes concernées par les indicateur de ce thème ne seront pas affectées.`,
  LIBRARY_INDIC_DELETE_CONFIRM: `Souhaitez-vous vraiment supprimer cet indicateur ?<br/>Tous les indicateurs qui s'y réfèrent seront archivés.`,
  LIBRARY_INDIC_USED_BY: `Non utilisé|Utilisé par 1 équipe|Utilisé par {n} équipes`,
  LIBRARY_INDIC_USE_AVERAGE: `Calculer la moyenne au lieu de cumuler les valeurs`,
  LIBRARY_INDIC_AVERAGE_HINT: `À la place du cumul des indicateurs, une moyenne des valeurs peut être plus utile notamment lorsque vous travaillez avec des pourcentages par exemple.<br/>Au besoin, il vous suffit de cocher cette case pour afficher une moyenne plutôt qu'un cumul.`,
  GW_OVERLAY: `Fenêtre des tournées terrain en cours`,
  HIDE_GW_OVERLAY: `Cacher la fenêtre des tournées terrain en cours`,
  RESET_GW_OVERLAY: `Réinitialiser la fenêtre des tournées terrain en cours`,
  NOTICE_GW_OVERLAY_IGNORE: `Êtes-vous sûr(e) de vouloir ignorer toutes les tournées terrain en cours ?<br><br>Cette fenêtre se réouvrira à la prochaine tournée terrain, elle peut être également réouverte dans les paramètres`,
  NAVIGATION_MENU: `Menu de navigation`,
  MENU: `Menu`,
  SHORTCUTS: `Raccourcis`,
  ADD_A_LINK: `Ajouter un lien`,
  RESET_DEFAULT: `Réinitialiser par défaut`,
  RESET: `Réinitialiser`,
  RESET_SUCCESS: `Réinitialisation réussie`,
  NAVIGATION_RESET_CONFIRM: `Êtes-vous sûr(e) de vouloir réinitialiser le menu de navigation par défaut ?`,
  NAVIGATION_CUSTOMIZE: `Personnaliser la barre de navigation`,
  NAVIGATION_LOCKED: `Cet élement est verouillé. Il ne peut pas être retiré.`,
  NAVIGATION_DISPLAY_NAME: `Afficher le titre en entier`,
  FILE_UPLOAD_SUCCESS: `Fichier enregistré | {nb} fichiers enregistrés`,
  FILE_UPLOAD_ERROR: `Erreur lors de l'envoi d'un fichier`,
  FILE_UPLOAD_ERROR_SIZE: `Le fichier dépasse la limite de 20Mo`,
  FILE_UPLOAD_ERROR_FORMAT: `Ce format de fichier n'est pas supporté (*.pdf, *.bmp, *.gif, *.jpg, *.png, *.xls, *.xlsx, *.ods, *.doc, *.docx, *.odt, *.ppt, *.odp)`,
  FILE_UPLOAD_ERROR_QUOTA: `Votre équipe a dépassé la limite de 100Mo sur Shizen`,
  FILE_DELETE_CONFIRM: `Êtes-vous sûr(e) de vouloir supprimer ce fichier ?<br>Si le fichier est utilisé dans une information, un problème ou une action, supprimer ce fichier le retirera de toutes les pages où il est utilisé | Êtes-vous sûr de vouloir supprimer ces fichiers ?<br>Si les fichiers sont utilisés dans une information, un problème ou une action, supprimer ces fichiers les retirera de toutes les pages où ils sont utilisés`,
  FILE_DELETE_SUCCESS: `Fichier supprimé avec succès  | {nb} fichiers supprimés avec succès`,
  FILE_DELETE_ERROR: `Échec de la suppression du fichier`,
  FILE_DELETE_ERROR_NO_ACCESS: `Votre équipe n'a pas accès à ce fichier`,
  FILE_REF_COUNT: `Non utilisé dans Shizen | Utilisé une fois dans Shizen | Utilisé {nb} fois dans Shizen`,
  FILES: `Fichiers`,
  ADD_FILES: `Ajouter des fichiers`,
  HOW_ADD_FILES: `De quelle manière souhaitez-vous ajouter des fichiers ?<br>Vous pouvez réutiliser des fichiers que vous ou un autre membre de l'entreprise a déjà ajouté, ou ajouter de nouveaux fichiers.<br><br>Vous pouvez également coller une image depuis le presse-papiers ci-dessous.`,
  SEARCH_ON_DATABASE: `Chercher sur Shizen`,
  PASTE_HERE: `Coller votre image ici`,
  PASTE_HERE_SHORTCUT: `Ctrl + V`,
  PREVIEW: `Prévisualiser`,
  DOWNLOAD: `Télécharger`,
  CONFIRM_DELETE_FILE: `Souhaitez-vous supprimer le fichier ?`,
  NO_PREVIEW: `Pas d'aperçu disponible`,
  SCHEDULE_PLANNING_ERROR: `Erreur de planification. Il semble que cette réunion ne peut plus être planifiée.`,
  INFO_AT_DATE: `Informations affichées à cette date ({nb})`,
  NO_INFO_AT_DATE: `Aucune information affichée à cette date`,
  ISHI_BRANCH_ENVIRONMENT: `Milieu`,
  ISHI_HINT: `Bienvenue dans l'outil de diagramme d'Ishikawa. Utilisez cet outil pour lister et structurer toutes les causes possibles qui entraînent un effet.<br>Créez une nouvelle cause en cliquant sur le bouton "Ajouter une cause" à la base d'une des branches. Et créez une "sous-cause" d'une cause (la cause d'une autre cause) en cliquant sur le bouton "+" à côté de celle-ci.<br>Si vous voulez déplacer un élément d'une branche à une autre, vous pouvez le faire glisser et le déposer au-dessus du nom d'une branche ou d'une autre cause.`,
  ISHI_BRANCH_MATERIALS: `Matière`,
  ISHI_BRANCH_MACHINES: `Machines`,
  ISHI_BRANCH_METHODS: `Méthodes`,
  ISHI_BRANCH_MEN: `Main d'oeuvre`,
  ISHI_BRANCHLESS_CAUSES: `Causes non triées`,
  ISHI_NO_BRANCHLESS_CAUSES: `Pas de cause non triée`,
  REMOVE_ANNOUNCEMENT: `Retirer l'annonce`,
  DISP_ALL_ANNOUNCEMENTS: `Afficher les annonces en cours de Shizen`,
  DISP_ANNOUNCEMENTS_HINT: `Si vous avez fermé une annonce sans avoir le temps de la lire, vous pouvez l'afficher à nouveau en cliquant ici.`,
  CURRENT_CLOSED_ANNOUNCEMENTS: `Annonces en cours fermées`,
  SHOW_DETAILS: `Afficher les détails`,
  HIDE_DETAILS: `Cacher les détails`,
  VISIBLE_CHART_PERIOD: `Période visible des graphes`,
  CHART_POINT_PERIOD: `Période d'un point des graphes`,
  DAILY_INDICATORS: `Indicateurs quotidiens`,
  DAILY_INDICATORS_OVER_THIRTY_DAYS: `@:message.DAILY_INDICATORS sur 30 jours`,
  DAILY_INDICATORS_DAY_VALUE: `@:message.DAILY_INDICATORS : Valeur du jour`,
  DAILY_INDICATORS_YESTERDAY_VALUE: `@:message.DAILY_INDICATORS : Valeur d'hier`,
  WEEKLY_INDICATORS: `Indicateurs hebdomadaires`,
  MONTHLY_INDICATORS: `Indicateurs mensuels`,
  PERIOD_START_DAY: `Jour du début de la période`,
  DEFAULT_PRESETS: `Pré-sélections par défaut`,
  CUSTOM_PRESETS: `Pré-sélections personnalisées`,
  MANAGE_PRESETS: `Gérer les pré-sélections`,
  HISTORY: `Historique`,
  DELETED_PLACEHOLDER: `[Élément supprimé]`,
  HISTORY_EMPTY: `L'historique est vide.`,
  HISTORY_THE_TEAM: `L'équipe "{team}" {didWhat}`,
  HISTORY_THE_TEAM_AND_USER: `{user} ({team}) {didWhat}`,
  HISTORY_CREATION_PB: `a remonté un problème ("{title}")`,
  HISTORY_CREATION_CAUSE: `a créé une cause ("{title}")`,
  HISTORY_CREATION_ACTION: `a créé une action ("{title}")`,
  HISTORY_DELETION_CAUSE: `a supprimé une cause`,
  HISTORY_DELETION_ACTION: `a supprimé une action`,
  HISTORY_EDIT_PB: `a modifié <b>{field}</b> du problème`,
  HISTORY_FIELD_PB_LWHAT: `le champ "quoi"`,
  HISTORY_FIELD_PB_LWHO: `le champ "qui"`,
  HISTORY_FIELD_PB_LWHERE: `le champ "où"`,
  HISTORY_FIELD_PB_LWHEN: `le champ "quand"`,
  HISTORY_FIELD_PB_LHOW: `le champ "comment"`,
  HISTORY_FIELD_PB_LHOWMUCH: `le champ "combien"`,
  HISTORY_FIELD_PB_LWHY: `le champ "pourquoi"`,
  HISTORY_FIELD_PB_IMPACT: `l'impact`,
  HISTORY_FIELD_PB_TYPES: `les types`,
  HISTORY_FIELD_PB_ZONES: `les lieux`,
  HISTORY_FIELD_PB_INDICATORS: `les indicateurs liés`,
  HISTORY_FIELD_PB_KEYWORDS: `les mots-clés`,
  HISTORY_FIELD_PB_DEADLINE: `la deadline`,
  HISTORY_FIELD_PB_LEADERS: `le responsable`,
  HISTORY_FIELD_PB_FILES: `les fichiers`,
  HISTORY_FIELD_PB_CAUSE: {
    TEXT: `le contenu @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    FILES: `les fichiers @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    CAUSE: `la cause parente @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    ISHIKAWABRANCH: `la branche Ishikawa @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    HIDEINSHEET: `la visibilité des causes`,
    ISVERIFIED: `le statut vérifié @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    ISREAL: `le statut réel @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
  },
  HISTORY_FIELD_PB_CAUSE_SUFFIX: `d'une cause`,
  HISTORY_FIELD_PB_ACTION: {
    NAME: `@:message.HISTORY_FIELD_ACTION_NAME @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    CAUSE: `@:message.HISTORY_FIELD_ACTION_CAUSE @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    LEADER: `@:message.HISTORY_FIELD_ACTION_LEADER @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    IMPACT: `@:message.HISTORY_FIELD_ACTION_IMPACT @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    PDCA: `@:message.HISTORY_FIELD_ACTION_PDCA @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    GAIN: `@:message.HISTORY_FIELD_ACTION_GAIN @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    GAINUNIT: `@:message.HISTORY_FIELD_ACTION_GAIN @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    DEADLINE: `@:message.HISTORY_FIELD_ACTION_DEADLINE @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    COMMENT: `@:message.HISTORY_FIELD_ACTION_COMMENT @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    FILES: `@:message.HISTORY_FIELD_ACTION_FILES @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    PLAN: `@:message.HISTORY_FIELD_ACTION_PLAN @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    STATE: `@:message.HISTORY_FIELD_ACTION_STATE @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    PROBLEM: `@:message.HISTORY_FIELD_ACTION_PROBLEM @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
  },
  HISTORY_FIELD_PB_ACTION_SUFFIX: `d'une action`,
  HISTORY_FIELD_PB_CREATED: `la date de création`,
  HISTORY_EDIT_ACTION: `a modifié <b>{field}</b> de l'action.`,
  HISTORY_FIELD_ACTION_NAME: `le nom`,
  HISTORY_FIELD_ACTION_CAUSE: `la cause liée`,
  HISTORY_FIELD_ACTION_LEADER: `le responsable`,
  HISTORY_FIELD_ACTION_IMPACT: `l'impact`,
  HISTORY_FIELD_ACTION_PDCA: `le PDCA`,
  HISTORY_FIELD_ACTION_GAIN: `les gains`,
  HISTORY_FIELD_ACTION_GAINUNIT: `@:message.HISTORY_FIELD_ACTION_GAIN`,
  HISTORY_FIELD_ACTION_DEADLINE: `la deadline`,
  HISTORY_FIELD_ACTION_COMMENT: `les commentaires`,
  HISTORY_FIELD_ACTION_FILES: `les fichiers`,
  HISTORY_FIELD_ACTION_PLAN: `le plan d'action`,
  HISTORY_FIELD_ACTION_STATE: `l'état`,
  HISTORY_FIELD_ACTION_PROBLEM: `le problème`,
  SETTINGS_USER_DATA_USAGE: `Le prénom, le nom, la photo et l'email des utilisateurs sont utilisés au sein de Shizen.<ul><li>Le prénom, le nom et la photo permettent à l'ensemble des autres utilisateurs d'identifier rapidement les responsables d'actions, de problèmes et d'autres éléments au sein du produit.</li><li>L'email permet à ceux qui le souhaitent de recevoir des notifications lors de certaines actions spécifiques, comme l'envoi d'action, le partage des fiches problème, etc.</li></ul>Ces données ne seront jamais utilisées en dehors de Shizen, ni communiquées à des tiers.<br>Vous avez la possibilité de demander l'anonymisation de vos données depuis cette page en cliquant sur le bouton "Supprimer". Dès lors, une demande sera envoyée directement aux administrateurs de Shizen qui pourront supprimer l'ensemble des données vous concernant.`,
  ERASE: `Effacer`,
  CONFIRM_USER_DATA_REMOVAL_REQUEST: `En cliquant sur le bouton ci-dessous, vous allez envoyer une demande de suppression des données de cet utilisateur. La suppression ou l'anonymisation de ces données devra être effectuée par le responsable d'équipe ou l'administrateur, celui-ci en sera notifié par courriel.\nVoulez-vous confirmer cette action ?`,
  USER_DATA_REMOVAL_DATE: `Cet utilisateur a effectué une demande de suppression le {date}`,
  ERASE_USER_DATA: `Effacer les données de l'utilisateur`,
  CONFIRM_ERASE_USER_DATA: `Êtes-vous sûr(e) de vouloir effacer les données de l'utilisateur ?\nIl existera toujours, mais ses nom, prénom, adresse courriel et sa photo seront supprimés.`,
  CANCEL_USER_DATA_REMOVAL_REQUEST: `Annuler la demande de suppression`,
  FOR_A_TOTAL_OF: `pour un total de {what}`,
  OUT_OF_WHAT: `sur {what}.`,
  MAYBE_LATER: `Plus tard`,
  DONT_ASK_AGAIN: `Ne plus demander`,
  DISPLAY_ALL_GROUPS: `Afficher tous les groupes`,
  VITALITY_HUB: `Centre de vitalité`,
  VITALITY: `Vitalité`,
  VITALITY_OVERALL: `Vitalité générale`,
  VITALITY_CRITERIA: `Critères de vitalité`,
  VH_TEAM_NAME: `Nom d'équipe`,
  VH_TEAMS_VITALITY: `Vitalité des équipes`,
  VH_SCORE: `Score`,
  VH_CRIT_BAD: `à analyser`,
  VH_CRIT_INADEQUATE: `à corriger`,
  VH_CRIT_ACCEPTABLE: `à améliorer`,
  VH_CRIT_GOOD: `à perfectionner`,
  VH_DELTA_INCREASE: `Hausse de {val} point | Hausse de {val} points`,
  VH_DELTA_DECREASE: `Baisse de {val} point | Baisse de {val} points`,
  VH_DELTA_NEITHER: `Pas de hausse ni de baisse`,
  VH_HIDE_DETAILS: `Cacher les détails`,
  VH_DISPLAY_DETAILS: `Afficher les détails`,
  VH_VITALITY_OVER_LAST_PERIODS: `Vitalité au cours des 6 dernières périodes`,
  VH_CRITERIA_OVER_LAST_PERIODS: `Répartition des critères au cours des 6 dernières périodes`,
  VH_DISPLAY_GROUPS: `Groupes à afficher`,
  VH_DISPLAY_CATEGORY: `Thématiques à afficher`,
  VH_DISPLAY_CRITERIA_ALL: `Tous`,
  VH_OPTIONS_FILTERS: `Options et filtres`,
  VH_FILTER_BY_CRITICALITY: `Filtrer par criticité`,
  VH_NO_FILTERED_CRITERIA: `Aucun critère à afficher avec ces filtres.`,
  VH_ADD_GROUP: `Ajouter un nouveau groupe d'équipes`,
  VH_NEW_GROUP: `Nouveau groupe`,
  VH_CONFIRM_DELETE_GROUP: `Voulez-vous vraiment supprimer ce groupe ?`,
  VH_CONFIRM_RESET_GROUPS: `Voulez-vous supprimer le dernier groupe et rétablir les groupes par défaut ?`,
  VH_RESET_GROUPS: `Supprimer et rétablir`,
  VH_DEFAULT_TEAMS_MANAGED: `Équipes managées par {name}`,
  VH_CRITICALITY_TABLE_USAGE: `Cochez/décochez les quatre cases ci-dessous pour afficher/masquer les critères selon leur criticité. Pour agrandir une case et en savoir plus sur lesdits critères, cliquez sur le titre de la case.`,
  VH_DISPLAY_QUICK_HELP: `Afficher le bandeau d'aide`,
  VH_HIDE_QUICK_HELP: `Cacher le bandeau d'aide`,
  VH_DISPLAY_HELP: `Afficher l'aide complète du Centre de Vitalité`,
  VH_TIP_SETUP_GROUPS: `Mettez en place les équipes ou groupes d'équipes dont vous voulez voir la vitalité.`,
  VH_TIP_VITALITY: `Pour avoir une vue d'ensemble des équipes qui vont bien et de celles qui ont besoin d'aide.`,
  VH_TIP_CRITERIA: `Et pour vous concentrer sur les critères qui demandent davantage d'attention.`,
  VH_TIP_DETAILS: `Puis affichez plus de détails par catégorie.`,
  VH_PH_GROUP_NAME: `Nom du groupe...`,
  VH_LOADING_WAIT: `Un chargement est déjà en cours. Veuillez attendre quelques instants...`,
  N_TEAMS: `Aucune équipe|1 équipe|{n} équipes`,
  N_USERS: `Aucun utilisateur|1 utilisateur|{n} utilisateurs`,
  DISPLAY_CHART: `Afficher le graphique`,
  HIDE_CHART: `Cacher le graphique`,
  VH_WHAT_TEAMS: `équipes`,
  VH_WHAT_PROBLEMS: `problèmes`,
  VH_WHAT_DMP: `données quotidiennes`,
  VH_WHAT_GEMBAWALKS: `tournées terrain`,
  VH_FINALIZING: `Finalisation...`,
  VH_LOADING: `Chargement des {what}...`,
  VH_WORKING: `Calcul de la vitalité : {what}...`,
  VH_READY: `Chargement terminé : {capWhat}`,
  VH_ERROR: `Erreur lors du chargement : {what}...`,
  VH_POINT_INCREASE: `Augmentation de {val} point | Augmentation de {val} points`,
  VH_POINT_DECREASE: `Diminution de {val} point | Diminution de {val} points`,
  VH_DEFAULT_CHART_NAME: `Scores`,
  VH_SHOW_ALL_SENSEI_HINTS: `Afficher les conseils du sensei`,
  VH_SHOW_SENSEI_HINT: `Afficher le conseil`,
  VH_HIDE_SENSEI_HINT: `Cacher le conseil`,
  VH_WELCOME_TOUR: `Bienvenue dans le Centre de Vitalité !<br>Voulez-vous une visite guidée ?`,
  VH_PB_REL_NUMBER: `Évolution du nombre de problèmes`,
  VH_PB_REL_NUMBER_TEXT: `{val}% de remontées de problème par rapport aux 5 derniers mois ({nProblems})`,
  VH_PB_SOLVED_REL_NUMBER: `Fréquence de résolution de problème`,
  VH_PB_SOLVED_REL_NUMBER_TEXT: `{val}% de résolutions de problème par rapport aux 5 derniers mois ({nProblems})`,
  VH_PB_TRUST: `Indice de confiance moyen des problèmes`,
  VH_PB_TRUST_TEXT: `{val}% d'indice de confiance des problèmes`,
  VH_PB_CAUSES_IN_COMPLETED: `Causes des problèmes`,
  VH_PB_CAUSES_IN_COMPLETED_TEXT: `{percVerified}% des problèmes terminés ont des causes vérifiées ({percAnalysis}% depuis l'analyse de causes).\n{percLinked}% des actions de résolution sont liées à des causes ({percLinkedTrue}% liées à des vraies causes)`,
  VH_PB_RECURRENCE: `Récurrence des problèmes`,
  VH_PB_RECURRENCE_TEXT: `{val} occurrences de "{text}"`,
  VH_PB_NO_RECURRENCE_TEXT: `Aucune récurrence notable parmi ces problèmes`,
  VH_PB_RESOLUTION: `Résolution des problèmes`,
  VH_PB_RESOLUTION_TEXT: `Dans les trois dernières périodes, {nReportedPb} et {nResolvedPb}`,
  VH_PB_RESOLUTION_NO_PROBLEMS: `Aucun problème remonté dans les trois dernières périodes`,
  VH_PB_LEAD_TIME: `Délai de résolution`,
  VH_PB_LEAD_TIME_TEXT_INC: `{val}% d'augmentation du délai de résolution ({displayTime})`,
  VH_PB_LEAD_TIME_TEXT_DEC: `{val}% de diminution du délai de résolution ({displayTime})`,
  VH_PB_TYPE_ZONE: `Répartition des problèmes par lieu ou par type`,
  VH_PB_TYPE_ZONE_TEXT_BOTH: `@:message.VH_PB_TYPE_ZONE_TEXT_ONLY_Z, @:message.VH_PB_TYPE_ZONE_TEXT_ONLY_T`,
  VH_PB_TYPE_ZONE_TEXT_ONLY_Z: `{zonePerc}% des problèmes ont été remontés dans "{zoneText}"`,
  VH_PB_TYPE_ZONE_TEXT_ONLY_T: `{typePerc}% des problèmes sont liés à "{typeText}"`,
  VH_PB_LATE: `Problèmes en retard`,
  VH_PB_TEXT_NONE_RELATED: `Aucun problème concerné`,
  VH_PB_LATE_TEXT_NOT_COMPLETED: `{nNotCompletedLate} problème en retard non terminé|{nNotCompletedLate} problèmes en retard non terminés`,
  VH_PB_LATE_TEXT_COMPLETED: `{nOnTime} problème terminé à l'heure|{nOnTime} problèmes terminés à l'heure`,
  VH_AC_NUMBER: `Évolution du nombre d'actions`,
  VH_AC_NUMBER_TEXT: `{val}% d'actions créées par rapport aux 5 dernières périodes ({nAction})`,
  VH_AC_ABS_NUMBER_TEXT: `{val} action créée | {val} actions créées`,
  VH_AC_LATE: `Actions en retard`,
  VH_AC_LATE_TEXT_NONE_RELATED: `Aucune action concernée`,
  VH_AC_LATE_TEXT_NOT_COMPLETED: `{nNotActedLate} action en retard non terminée|{nNotActedLate} actions en retard non terminées`,
  VH_AC_LATE_TEXT_COMPLETED: `{nOnTime} / {nTotalActed} actions terminées à l'heure`,
  VH_AC_POSTPMT: `Décalages des actions`,
  VH_AC_POSTPMT_TEXT_NONE_COMPLETED: `Aucne action terminée durant cette période`,
  VH_AC_POSTPMT_TEXT_ACTIONS: `Aucune action décalée|{nActions} action décalée {suffix}|{nActions} actions décalées {suffix}`,
  VH_AC_LEAD_TIME: `Délai des actions`,
  VH_AC_LEAD_TIME_TEXT_INC: `{val}% d'augmentation du délai des actions ({displayTime})`,
  VH_AC_LEAD_TIME_TEXT_DEC: `{val}% de diminution du délai des actions ({displayTime})`,
  VH_GW_ON_SCHEDULE: `Respect des tournées terrain planifiées`,
  VH_GW_ON_SCHEDULE_NONE_PLANNED: `Aucune tournée planifiée`,
  VH_GW_ON_SCHEDULE_TEXT: `{nCompleted} / {nPlanned} tournées terminées`,
  VH_GW_NOK_RECURRENCE: `Récurrence des items NOK lors de tournées terrain`,
  VH_GW_NOK_RECURRENCE_PERCENTAGE: `{perc}% d'éléments OK dans les tournées terrain. {recurrenceInfo}`,
  VH_GW_NOK_RECURRENCE_TEXT: `{val} occurrences de "{text}"`,
  VH_GW_NOK_RECURRENCE_NONE_TEXT: `Aucune récurrence parmi ces tournées terrain`,
  VH_GW_NONE: `Aucune tournée terrain effectuée`,
  VH_GW_PB_RECURRENCE: `Récurrence des problèmes lors de tournées terrain`,
  VH_GW_RATINGS: `Évaluation des équipes auditées`,
  VH_GW_RATINGS_NONE_TEXT: `Les tournées terrain n'ont pas été évaluées`,
  VH_GW_RATINGS_TEXT: `Les évaluations sur le ressenti sont de {mood}/10 et la pertinence de {relevance}/10`,
  VH_GW_NOK_WITHOUT_PROBLEM: `Éléments NOK qui ne font pas l'objet d'un problème`,
  VH_GW_NOK_WITHOUT_PROBLEM_TEXT: `{perc}% des éléments NOK ont un problème associé. ({nWithProblems} / {nTotal})`,
  VH_I_NO_VALUES: `Aucune valeur`,
  VH_I_EXCEEDING: `Valeurs en dehors de l'objectif`,
  VH_I_EXCEEDING_TEXT: `Au total, {nb}/{nValues} dépassent l'objectif`,
  VH_I_RECURRENCE: `Récurrence des dépassements d'objectif`,
  VH_I_RECURRENCE_TEXT: `Objectif dépassé {val} fois sur "{text}" ({details})`,
  VH_I_RECURRENCE_NONE_TEXT: `Pas de dépassement notoire`,
  VH_I_PB: `Nombre de problèmes par indicateur`,
  VH_I_PB_TEXT: `{problemsNumber} liés à "{text}"`,
  VH_I_PB_NONE_TEXT: `Aucun problème lié aux indicateurs`,
  VH_I_OUTLIERS: `Valeurs d'indicateur anormalement éloignées`,
  VH_I_OUTLIERS_NONE_TEXT: `Aucun indicateur ne présente des valeurs anormalement éloignées`,
  VH_I_OUTLIERS_TEXT: `{perc}% des indicateurs présentent des valeurs anormalement éloignées ({nIndicatorsWithOutliers} / {nIndicators})`,
  VH_M_ON_SCHEDULE: `Respect des réunions planifiées`,
  VH_M_ON_SCHEDULE_NONE_PLANNED: `Aucune réunion planifiée`,
  VH_M_ON_SCHEDULE_TEXT: `{nCompleted} / {nPlanned} réunions terminées`,
  VH_M_RATING: `Évaluation des réunions`,
  VH_M_NO_RATINGS: `Aucune évaluation`,
  VH_M_NO_MEETING: `Aucune réunion réalisée`,
  VH_M_RATING_TEXT: `La note moyenne attribuée aux réunions est {value} ({scoreClosest})`,
  VH_M_DURATION: `Durée des réunions planifiées`,
  VH_M_DURATION_TEXT: `En moyenne, les réunions sont en écart de {gap} par rapport à la durée planifiée`,
  VH_M_PARTICIPANTS: `Participation aux réunions`,
  VH_M_PARTICIPANTS_TEXT: `En moyenne, {score}% des participants attendus sont présents`,
  VH_I_PB_WHEN_RED: `Problèmes liés aux indicateurs hors objectif`,
  VH_I_PB_WHEN_RED_TEXT: `{score}% des périodes hors objectif ont un problème associé  ({nWithProblem} / {nTotal})`,
  VH_I_NO_RED_PERIOD: `Les indicateurs ne sont pas hors objectif`,
  ISSUE_BUGS: `Bugs`,
  ISSUE_BUG: `Bug`,
  ISSUE_IMPROVEMENTS: `Améliorations`,
  ISSUE_IMPROVEMENT: `Amélioration`,
  ISSUE_NEW_ISSUE: `Nouveau`,
  ISSUE_PENDING: `En attente`,
  ISSUE_ON_GOING: `En cours`,
  ISSUE_FINISHED: `Terminé`,
  ISSUE_REFUSED: `Refusé`,
  ISSUE_ISSUE_ID: `Numéro du ticket`,
  ISSUE_CREATION_DATE: `Créé le`,
  AUTHOR: `Auteur`,
  ISSUE_DISCUSSION: `Discussion`,
  ISSUE_NO_COMMENTS: `L'espace disccussion est vide.`,
  ISSUE_NO_ATTACHMENTS: `Aucun fichier n'est disponible.`,
  ISSUE_ATTACHMENTS: `Fichiers`,
  FREE_VERSION_RESTRICTED: `Vous ne pouvez pas accéder à ce contenu depuis une version gratuite. Veuillez contacter Shizen pour obtenir plus d'informations et débloquer l'accès à toutes les fonctionnalités.`,
  GET_FULL_SHIZEN_LINK: `<a class="shizen-upgrade-link" href="https://shizen.io/demo" target="_blank">Obtenir la version complète</a>`,
  GET_FULL_SHIZEN: `Obtenir la version complète`,
  GW_INDICATORS_HINT: `Les indicateurs de tournées terrain permettent eux personnes en charge des tournées d'être plus précis lorsqu'ils collectent des données lors de leurs visites sur le terrain. De plus, Les données peuvent être compilées et affichées sur des graphes à court et long termes pour analyser l'évolution des contrôles des tournées terrain.`,
  DISPLAY_NEO_HINTS: `Afficher les conseils de Néo`,
  INDIC_NEO_REPORT_PROBLEM: `Les 3 dernières valeurs de l'indicateur sont hors objectif.<br>Voulez-vous remonter un problème à ce sujet ?`,
  DONT_SHOW_AGAIN_TEN_DAYS: `Ne plus afficher pendant 10 jours`,
  COMING_SOON: `Bientôt disponible`,
  N_MEMBERS: `Aucun membre | 1 membre | {nb} membres`,
  CURRENT_TEAM: `Équipe actuelle`,
  OTHER_TEAMS: `Autres équipes`,
  ACCOUNT_SWITCHED_TEAM: `Ce compte est passé sur une autre équipe. Vous devriez rafraîchir la page maintenant mais vous pouvez le faire plus tard.<br><br>Si vous ne raffraîchissez pas la page dès maintenant, vous pouvez être confronté à des problèmes d'accès.`,
  ACCOUNT_SWITCH_REFRESH_NOW: `Rafraîchir maintenant`,
  ACCOUNT_SWITCH_REFRESH_LATER: `Rafraîchir plus tard`,
  MY_ACCOUNT: `Mon compte`,
  MY_ACCOUNT_SHORT: `Compte`,
  MY_PROBLEMS: `Mes problèmes`,
  MY_ACTIONS: `Mes actions`,
  MY_SENT_ACTIONS: `Mes actions envoyées`,
  MY_ACTIONS_HINT: `Liste des actions dont vous êtes le responsable.`,
  MY_SENT_ACTIONS_HINT: `Liste des actions que vous avez créées, et qui ont été envoyées à d'autres équipes.`,
  USER_ACCOUNT: `Compte utilisateur`,
  EMAIL_ADDRESS: `Adresse email`,
  PHONE_NUMBER: `Numéro de téléphone`,
  CHANGE_MY_PASSWORD: `Modifier mon mot de passe`,
  WELCOME_TO_SHIZEN: `Bienvenue sur Shizen !`,
  DATA_USAGE_SUMMARY: `Pour fonctionner correctement, Shizen recueille quelques informations sur vous (prénom, nom, adresse email). Ces données sont stockées dans un environnement sécurisé et ne seront jamais diffusées publiquement, ni communiquées à des organismes tiers par la société Shizen.`,
  DATA_USAGE_MY_ACCOUNT: `Vous avez la possibilité de modifier ces informations à tout moment depuis l’espace "@:message.MY_ACCOUNT".`,
  DATA_USAGE_NAMES_TITLE: `Nom et prénom`,
  DATA_USAGE_NAMES: `Le nom et le prénom sont utilisés pour afficher la liste des membres d'une équipe, la personne responsable d'une action ou d'une résolution de problème,un participant à une réunion, ...`,
  DATA_USAGE_EMAIL_TITLE: `Adresse email`,
  DATA_USAGE_EMAIL: `L'adresse email vous permet de réinitialiser votre mot de passe. Certaines fonctionnalités vous permettront bientôt de recevoir des email lorsqu'un utilisateur modifie une fiche problème ou une action.`,
  DATA_USAGE_PICTURE_TITLE: `Photo`,
  DATA_USAGE_PICTURE: `La photo est utilisée pour les mêmes raisons que le nom et le prénom, pour un aperçu plus visuel.`,
  DEFAULT_HOME_PAGE: `Page d'accueil par défaut (pour remplacer le dashboard)`,
  FILTER_RADIO_ITEMS: `Filtrer les éléments`,
  SETTINGS_MEETINGS_SAVED_AUTOMATICALLY: `Les paramètres de réunions sont automatiquement enregistrés.`,
  FILTER_MEETINGS: `Filtrer les réunions`,
  NO_FILTER_SELECTED: `Aucun filtre sélectionné`,
  MEETING_N_STEPS: `Aucune étape | 1 étape | {n} étapes`,
  CONFIG_ADMIN: `Config / Admin`,
  BOLD: `Gras`,
  ITALIC: `Italique`,
  UNDERLINE: `Souligné`,
  STRIKETHROUGH: `Texte barré`,
  HIGHLIGHT: `Surligner`,
  HEADING_1: `Titre 1`,
  HEADING_2: `Titre 2`,
  PARAGRAPH: `Paragraphe`,
  BULLET_LIST: `Liste à puces`,
  NUMBERED_LIST: `Liste numérotée`,
  CHECK_LIST: `Checklist`,
  BLOCKQUOTE: `Citation`,
  HORIZONTAL_LINE: `Ligne horizontale`,
  CLEAR_FORMATTING: `Effacer la mise en forme`,
  UNDO: `Annuler`,
  REDO: `Rétablir`,
  BULLET_POINT: `•`,
  COMMA: `,`,
  STATS_OVERVIEW_TITLE: `Statistiques utilisateurs`,
  STATS_NODATA: `Il n'y a aucune donnée disponible.`,
  STATS_STATUS_ONLINE: `Connecté`,
  STATS_STATUS_OFFLINE: `Hors-ligne`,
  STATS_STATUS_OFFLINE_COMPANY: `Aucun utilisateur en ligne`,
  STATS_STATUS_AFK: `Absent`,
  STATS_STATUS_AFK_COMPANY: `Dernier utilisateur absent`,
  SINCE: `depuis`,
  OVERVIEW_CREATED_PB: `Aucun problème créé | 1 problème créé | {n} problèmes créés`,
  OVERVIEW_FINISHED_PB: `Aucun problème terminé | 1 problème terminé | {n} problèmes terminés`,
  CONNECTIONS: `Connexions`,
  OVERVIEW_REFRESH: `Rafraîchir les données`,
  OVERVIEW_REFRESH_WARNING: `Veuillez rafraîchir les données afin de mettre à jour les informations.`,
  LIST_OF_COMPANIES: `Liste des entreprises`,
  LIST_OF_TEAMS: `Liste des équipes`,
  LIST_OF_USERS: `Liste des utilisateurs`,
  SUMMARY_STATS: `Résumé des statistiques`,
  COMPANIES: `Entreprises`,
  CREATED_ACTIONS: `Créées`,
  CREATED_PROBLEMS: `Créés`,
  FINISHED_ACTIONS: `Terminées`,
  FINISHED_PROBLEMS: `Terminés`,
  SHORT_DAY: `j`,
  ONLINE: `En ligne`,
  ABSENT: `Absent`,
  OFFLINE: `Hors-ligne`,
  COMPANY: `Entreprise`,
  AVERAGE_CREATION_TIME: `Temps moyen de création`,
  REPORTED_ON_JIRA: `Signalé sur Jira`,
  SHIZEN_STATS: `Statistiques Shizen`,
  // Charts messages
  CHART_CATEGORY_MARKETING: `Marketing`,
  CHART_CATEGORY_DEVELOPMENT: `Développement`,
  CHART_CATEGORY_CUSTOMERSUCCESS: `Customer Success`,
  CHART_CATEGORY_PRODUCTLIFE: `Vie Du Produit`,
  CHARTS_CREATED_ACTIONS: `Nombre d'actions créées`,
  CHARTS_FINISHED_ACTIONS: `Nombre d'actions terminées`,
  CHARTS_ACTIONS_UNIT: `actions`,
  CHARTS_CREATED_PB: `Nombre de problèmes créés`,
  CHARTS_FINISHED_PB: `Nombre de problèmes terminés`,
  CHARTS_PB_UNIT: `problèmes`,
  CHARTS_FINISHED_MEETINGS: `Nombre de réunions terminées`,
  CHARTS_MEETINGS_UNIT: `réunions`,
  CHARTS_TIME_CREATING_ACTION: `Temps de création d'une action`,
  CHARTS_TIME_CREATING_PB: `Temps de création d\'un problème`,
  CHARTS_BUGS_REPORTED: `Nombre de bugs remontés`,
  CHARTS_BUGS_UNIT: `bugs`,
  CHARTS_TASKS_REPORTED: `Suggestions d'amélioration remontées`,
  CHARTS_TASKS_UNIT: `tâches`,
  CHARTS_TIME_ONLINE: `Temps en ligne`,
  CHARTS_TIME_OFFLINE: `Temps hors-ligne`,
  CHARTS_CONNECTION_FREQUENCY: `Nombre de connexions`,
  CHARTS_LOGIN_UNIT: `connexions`,
  COMPLETED_GW_SEE_PARTICIPANTS: `Participants`,
  COMPLETED_GW_PARTICIPATING_TEAM: `Équipe participante`,
  COMPLETED_GW_NB_THIS_GW: `Participations à cette TT`,
  COMPLETED_GW_NB_ALL_GW: `Nombre de TT réalisées au total`,
  COMPLETED_GW_EMPTY: `Aucun participant n'a été attribué à cette tournée de terrain.`,
  WAIT_INDICATORS_LOADED: `Veuillez attendre que les indicateurs soient chargés.`,
  ACTIONS_PER_CAUSE_MODAL_TITLE: `Actions de la cause`,
  ADD_ACTION_PER_CAUSE: `Ajouter une action liée à cette cause`,
  NO_ACTION_PLAN: `Aucun plan d'action`,
  IMPACT_LOW: `Faible`,
  IMPACT_MODERATE: `Moyen`,
  IMPACT_SIGNIFICANT: `Important`,
  IMPACT_CRITICAL: `Critique`,
  IMPACT_DISPLAY: `{val} - {text}`,
  NO_SELECTION: `Aucune sélection`,
  // Rating Modal
  RATINGS: `Avis`,
  RATE: `Note`,
  GLOBAL_RATING_TITLE: `Un avis sur Shizen ?`,
  RATING_TITLE: `Votre avis nous intéresse !`,
  GLOBAL_RATING_SUBTITLE_INTRO: `Nous récoltons des avis sur le produit afin de nous améliorer et de nous permettre de connaître votre ressenti face à celui-ci.`,
  GLOBAL_RATING_SUBTITLE: `Recommanderiez-vous Shizen à votre entourage ?`,
  I_DONT_RECOMMEND: `Je ne recommande pas`,
  RATING_STATUS_0: `Très difficile`,
  RATING_STATUS_1: `Difficile`,
  RATING_STATUS_2: `Normal`,
  RATING_STATUS_3: `Facile`,
  RATING_STATUS_4: `Très facile !`,
  RATING_SUCCESS_THANKS: `Merci pour votre retour !`,
  RATING_BUTTON_NEVER_AGAIN: `Ne plus me demander`,
  RATING_NEVER_AGAIN_MESSAGE: `Nous ne vous demanderons plus d'avis sur cette page ou cette fonctionnalité.`,
  // Rating Modal messages by ID
  RATING_MESSAGE_1: `Que pensez-vous de la facilité à remonter un problème ?`,
  RATING_MESSAGE_2: `Que pensez-vous de la facilité à entrer un indicateur ?`,
  RATING_MESSAGE_3: `Que pensez-vous de la facilité à créer une action ?`,
  RATING_MESSAGE_4: `Que pensez-vous de la facilité à créer une réunion ?`,
  RATING_MESSAGE_5: `Que pensez-vous de la facilité à diriger une réunion ?`,
  RATING_MESSAGE_6: `Que pensez-vous de la facilité à réaliser une tournée de terrain ?`,
  // 7 is the global message defined in the rating-modal component itself
  RATING_MESSAGE_8: `Que pensez-vous de la facilité à créer une information ?`,
  RATING_MESSAGE_9: `Que pensez-vous de la facilité à gérer les indicateurs ?`,
  RATING_MESSAGE_10: `Que pensez-vous de la facilité à gérer les problèmes ?`,
  RATING_MESSAGE_11: `Que pensez-vous de la facilité à gérer les actions ?`,
  RATING_MESSAGE_12: `Que pensez-vous de la facilité à créer une page paramétrable ?`,
  // Excel exported categories
  RATING_EXPORT_BUTTON: `Exporter les notes`,
  // Those categories below are generated from RatingController.php and are parsed in the exportRatingsToExcel function in rating-utils.js
  RATING_PROBLEM_CREATION: `Création d'un problème`,
  RATING_INDICATOR_INPUT: `Saisie d'un indicateur`,
  RATING_ACTION_CREATION: `Création d'une action`,
  RATING_MEETING_CREATION: `Lancer une réunion`,
  RATING_MEETING_LEAD: `Diriger une réunion`,
  RATING_GEMBA_WALK_LEAD: `Réalisation d'une TT`,
  RATING_GLOBAL: `Note globale`,
  RATING_INFORMATION_CLARITY: `Création des informations`,
  RATING_INDICATOR_MANAGEMENT: `Gestion des indicateurs`,
  RATING_PROBLEM_MANAGEMENT: `Gestion des problèmes`,
  RATING_ACTION_MANAGEMENT: `Gestion des actions`,
  RATING_CONFIGURABLE_PAGE_CREATION: `Création d'une page paramétrable`,
  VALUE: `Valeur`,
  STEP_VALIDATION: `Validation d'étape`,
  LAST_CONNECTION: `Dernière connexion le`,
  FIRST_CONNECTION: `Première connexion le`,
  CREATED: `Créé le`,
  TEAM_NOT_FOUND: `Equipe non trouvée`,
  CANNOT_SAVE_TEAM_PARAMETERS: `Les paramètres d'équipe n'ont pas pu être enregistrés`,
  USER_NOT_FOUND: `Utilisateur non trouvé`,
  NOTHING_TO_UPDATE: `Rien à mettre à jour`,
  CONFIG_RESTRICT_SETTING_ACCESS_USERS: `Restreindre l'accès au paramétrage`,
  CONFIG_RESTRICT_SETTING_ACCESS_USERS_HINT: `En cochant cette option, seuls les utilisateurs spécialement autorisés pourront modifier les paramètres de leurs équipes`,
  CONFIG_RESTRICT_PROBLEM_CREATION_UPDATE: `Restreindre la création et la mise à jour des problèmes`,
  CONFIG_RESTRICT_PROBLEM_CREATION_UPDATE_HINT: `En cochant cette option, seuls les utilisateurs spécialement autorisés pourront créer et mettre à jour les problèmes`,
  CONFIG_PROBLEM_UPDATE_NOTIFICATION_FIELDS: `Liste des champs de la fiche problème pour lesquels il faut généré une notification`,
  CONFIG_PROBLEM_UPDATE_NOTIFICATION_FIELDS_PLACEHOLDER: `Liste des champs séparés par une virgule. ex: deadline,description`,
  CONFIG_PROBLEM_UPDATE_NOTIFICATION_FIELDS_HINT: `En remplissant cette option, les champs saisis génèreront une notification en cas de modification sur la fiche problème. En laissant vide, tous les champs génèreront une notification`,
  ERROR_UNAUTHORIZE: `Non autorisé`,
  EVENT: `Évènement`,
  EVENTS: `Évènements`,
  N_EVENTS: `Aucun évènement | 1 évènement | {nb} évènements`,
  GOT_IT: `J'ai compris !`,
  UPCOMING_EVENTS: `Prochains évènements`,
  SETTINGS_PROBLEMS_ADD_FIELDS: `Afficher des champs supplémentaires dans la liste`,
  HIDE_ADDITIONAL_FIELDS: `Cacher les champs supplémentaires`,
  OFFLINE_MODE_ON: `Vous êtes en mode hors-ligne`,
  OFFLINE_MODE_SYNC: `Repasser en ligne`,
  OFFLINE_MODE_SLOW_REQUESTS: `La connexion internet prend un peu de temps. Voulez-vous passer hors-ligne ?`,
  OFFLINE_MODE_TURN_ON: `Mode hors-ligne`,
  OFFLINE_MODE_PROMPT_OFF: `Voulez-vous revenir en ligne ?`,
  OFFLINE_MODE_PROMPT_OFF_NEED_SYNC: `Shizen aura besoin d'effectuer une courte syncronisation pour envoyer vos données en ligne.`,
  OFFLINE_MODE_SYNCING: `Shizen syncronise vos données. Veuillez patienter jusqu'à la fin du chargement ou annuler la syncronisation pour rester hors-ligne.`,
  OFFLINE_MODE_SYNCING_OVER: `La synchronisation est terminée. Vous pouvez fermer cette fenêtre et utiliser Shizen en ligne.`,
  OFFLINE_MODE_SYNCING_OVER_ERROR: `La synchronisation a rencontré des erreurs. Veuillez vous assurer d'être connecté à internet et essayer à nouveau.`,
  OFFLINE_PROBLEMS: `Problèmes créés hors connexion`,
  OFFLINE_ACTIONS: `Actions créées hors connexion`,
  NETWORK_MGR_CREATE: `Création`,
  NETWORK_MGR_UPDATE: `Modification`,
  NETWORK_MGR_DELETE: `Suppression`,
  NETWORK_MGR_NAME: `{type} : {dataType}`,
};

export default messages;
